/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import authHeader from './auth-header';
import http from './http-common';
import { API_URLU } from '../config/constant';
const getUserById = (id) => {
  return axios.get(API_URLU + 'user/' + id, { headers: authHeader() });
};

const getDaySales = (branch_code, collection_date, cmp_id) => {
  return axios.get(API_URLU + 'day_sales/' + branch_code + '/' + collection_date + '/' + cmp_id, { headers: authHeader() });
};

const getUserSales = (createdBy, status) => {
  return axios.get(API_URLU + 'sales/' + createdBy + '/' + status, { headers: authHeader() });
};

const getAllSales = (status) => {
  return axios.get(API_URLU + 'sales/' + status, { headers: authHeader() });
};

const getPendingSales = (cmp_id, usr_id) => {
  return axios.get(API_URLU + 'pending_sales/' + cmp_id + '/' + usr_id, { headers: authHeader() });
};

const getApprovedSales = (cmp_id) => {
  return axios.get(API_URLU + 'approved-sales/' + cmp_id, { headers: authHeader() });
};

const getUserShops = (id) => {
  return axios.get(API_URLU + 'user_shops/' + id, { headers: authHeader() });
};

const getAllShops = (id) => {
  return axios.get(API_URLU + 'all_shops/' + id, { headers: authHeader() });
};

const getUsers = () => {
  return axios.get(API_URLU + 'user', { headers: authHeader() });
};

const postUser = (data) => {
  return axios.post(API_URLU + 'user', data, { headers: authHeader() });
};

const getCompById = (id) => {
  return axios.get(API_URLU + 'company/' + id, { headers: authHeader() });
};

const getCompanies = () => {
  return axios.get(API_URLU + 'company', { headers: authHeader() });
};

const getInsuranceCompanies = () => {
  return axios.get(API_URLU + 'insurance-companies', { headers: authHeader() });
};

const postComp = (data) => {
  return axios.post(API_URLU + 'company', data, { headers: authHeader() });
};

const getSystemById = (id) => {
  return axios.get(API_URLU + 'system' + id, { headers: authHeader() });
};

const getMaxDate = (cmpid, branch_code) => {
  return axios.get(API_URLU + 'max-date/' + cmpid + '/' + branch_code, { headers: authHeader() });
};

const getSaleStatus = (cmpid, branch_code) => {
  return axios.get(API_URLU + 'sale-status/' + cmpid + '/' + branch_code, { headers: authHeader() });
};

const getPastDays = (status) => {
  return axios.get(API_URLU + 'open-days/' + status, { headers: authHeader() });
};

const getDaysStatus = () => {
  return axios.get(API_URLU + 'check-days', { headers: authHeader() });
};

const getSystems = () => {
  return axios.get(API_URLU + 'system', { headers: authHeader() });
};

const postSystem = (data) => {
  return axios.post(API_URLU + 'system', data, { headers: authHeader() });
};

const postUserComp = (data) => {
  return axios.post(API_URLU + 'ucompany', data, { headers: authHeader() });
};

// const getUserCompbk = (data) => {
//   return axios.get(API_URLU + 'ucompany/', data, { headers: authHeader() });
// };

const getUserComp = (id) => {
  return axios.get(API_URLU + 'user-companies?userId=' + id, { headers: authHeader() });
};

const postUserSystems = (data) => {
  return axios.post(API_URLU + 'user-systems', data, { headers: authHeader() });
};

const getCompSystems = () => {
  return axios.get(API_URLU + 'company-systems', { headers: authHeader() });
};

const getUserCompSystems = () => {
  return axios.get(API_URLU + 'user-company-systems', { headers: authHeader() });
};

const getUserCompUSystems = () => {
  return axios.get(API_URLU + 'user-company-usystems', { headers: authHeader() });
};

const getCustomerById = (data) => {
  return axios.get(API_URLU + 'customerCode?cmpId=' + data.cmpId + '&custCode=' + data.custCode, { headers: authHeader() });
};

const getCustomerByCmpId = (data) => {
  return axios.get(API_URLU + 'cmp_customer/' + data.id + '/' + data.offset + '/' + data.pageSize, { headers: authHeader() });
};

const getCustomerByCmpIdAndId = (data) => {
  return axios.get(API_URLU + 'cmp_customer-id/' + data.id + '/' + data.nationalId + '/' + data.offset + '/' + data.pageSize, {
    headers: authHeader()
  });
};

const getCustomers = () => {
  return axios.get(API_URLU + 'customer', { headers: authHeader() });
};

const postCustomer = (data) => {
  return axios.post(API_URLU + 'customer', data, { headers: authHeader() });
};

const postSale = (data) => {
  return axios.post(API_URLU + 'icr_sales', data, { headers: authHeader() });
};

const postDay = (data) => {
  return axios.post(API_URLU + 'open-days', data, { headers: authHeader() });
};

const putSale = (id, data) => {
  return axios.put(API_URLU + 'icr_sales/' + id, data, { headers: authHeader() });
};

const putVatRate = (id, data) => {
  return axios.put(API_URLU + 'vat-rates/' + id, data, { headers: authHeader() });
};

const putStdRate = (id, data) => {
  return axios.put(API_URLU + 'standard-rates/' + id, data, { headers: authHeader() });
};

const putGenRate = (id, data) => {
  return axios.put(API_URLU + 'general-rates/' + id, data, { headers: authHeader() });
};

const putIstPeriod = (id, data) => {
  return axios.put(API_URLU + 'ist-periods/' + id, data, { headers: authHeader() });
};

const putIstSuppliers = (id, data) => {
  return axios.put(API_URLU + 'ist-suppliers/' + id, data, { headers: authHeader() });
};

const putDay = (id, data) => {
  return axios.put(API_URLU + 'open-days/' + id, data, { headers: authHeader() });
};

const getSalesByDate = (cmp_id, usr_id, sdate, edate) => {
  return axios.get(API_URLU + 'sales_date/' + cmp_id + '/' + usr_id + '/' + sdate + '/' + edate, { headers: authHeader() });
};

const getAdminSalesByDate = (cmp_id, sdate, edate) => {
  return axios.get(API_URLU + 'admin-datesales/' + cmp_id + '/' + sdate + '/' + edate, { headers: authHeader() });
};

const getSalesByShop = (cmp_id, branch_code, usr_id, first_date, last_date) => {
  return axios.get(API_URLU + 'sales_shop/' + cmp_id + '/' + branch_code + '/' + usr_id + '/' + first_date + '/' + last_date, {
    headers: authHeader()
  });
};

const getAdminSalesByShop = (cmp_id, branch_code, first_date, last_date) => {
  return axios.get(API_URLU + 'admin-shopsales/' + cmp_id + '/' + branch_code + '/' + first_date + '/' + last_date, {
    headers: authHeader()
  });
};

const delSale = (id) => {
  return axios.delete(API_URLU + 'icr_sales/' + id, { headers: authHeader() });
};

const delVatRate = (id) => {
  return axios.delete(API_URLU + 'vat-rates/' + id, { headers: authHeader() });
};

const delStdRate = (id) => {
  return axios.delete(API_URLU + 'standard-rates/' + id, { headers: authHeader() });
};

const delGenRate = (id) => {
  return axios.delete(API_URLU + 'general-rates/' + id, { headers: authHeader() });
};

const delIstProduct = (id) => {
  return axios.delete(API_URLU + 'ist-products/' + id, { headers: authHeader() });
};

const delCashRate = (id) => {
  return axios.delete(API_URLU + 'ist-cashRates/' + id, { headers: authHeader() });
};

const delMarkup = (id) => {
  return axios.delete(API_URLU + 'ist-checkOffMarkup/' + id, { headers: authHeader() });
};

const putCustomer = (data) => {
  return axios.put(API_URLU + 'customer/' + data.custId, data, { headers: authHeader() });
};

const getEmployeeById = (id) => {
  return axios.get(API_URLU + 'chr_employee/' + id, { headers: authHeader() });
};

const getEmployeeByUsername = (name) => {
  return axios.get(API_URLU + 'chr_by_username/' + name, { headers: authHeader() });
};

const getEmployees = () => {
  return axios.get(API_URLU + 'chr_employee', { headers: authHeader() });
};

const getPagedEmployees = (offset, pageSize) => {
  return axios.get(API_URLU + 'employee/' + offset + '/' + pageSize, { headers: authHeader() });
};

const postEmployee = (data) => {
  return axios.post(API_URLU + 'employee', data, { headers: authHeader() });
};

const putEmployee = (id, data) => {
  return axios.put(API_URLU + 'employee/' + id, data, { headers: authHeader() });
};

const getClassification = () => {
  return axios.get(API_URLU + 'classification', { headers: authHeader() });
};

const getGeneral = () => {
  return axios.get(API_URLU + 'general', { headers: authHeader() });
};

const postTempBranch = (data) => {
  return axios.post(API_URLU + 'tbranch', data, { headers: authHeader() });
};

const getTempBranch = () => {
  return axios.get(API_URLU + 'tbranch', { headers: authHeader() });
};

const saveInvoice = (invoice) => {
  return axios.post(API_URLU + 'SaveInvoice', invoice, { headers: authHeader() });
};

const getInvoiceInfo = () => {
  return axios.get(API_URLU + 'getInfo', { headers: authHeader() });
};

const getScheduledLeaves = () => {
  return axios.get(API_URLU + 'scheduled_leaves', { headers: authHeader() });
};

const postLeaveSchedule = (data) => {
  return axios.post(API_URLU + 'scheduled_leaves', data, { headers: authHeader() });
};

const getLeaveAccruals = () => {
  return axios.get(API_URLU + 'leave_accruals', { headers: authHeader() });
};

const getLeaveApplications = () => {
  return axios.get(API_URLU + 'leave_applications', { headers: authHeader() });
};

const postLeaveApplication = (data) => {
  return axios.post(API_URLU + 'leave_applications', data, { headers: authHeader() });
};

const getLeaveTransactions = () => {
  return axios.get(API_URLU + 'leave_transactions', { headers: authHeader() });
};

const getLeaveRejections = () => {
  return axios.get(API_URLU + 'leave_rejections', { headers: authHeader() });
};

const getLeaveTypes = () => {
  return axios.get(API_URLU + 'leave_types', { headers: authHeader() });
};

const getReturnDate = (data) => {
  return axios.get(
    API_URLU +
      'return_date?startDate=' +
      data.startDate +
      '&appliedDays=' +
      data.appliedDays +
      '&leaveCode=' +
      data.leaveCode +
      '&cmpId=' +
      data.cmpId,
    { headers: authHeader() }
  );
};

// const uploadFile = (file, onUploadProgress) => {
//   let formData = new FormData();

//   formData.append("file", file);
//   return axios.post(API_URLU + "singleUpload/", formData, { headers: authHeader(), onUploadProgress })}

// const getFiles = () => {
//   return axios.get(API_URLU + "files/", { headers: authHeader() })}

// const uploadFile = (file) => {
//   let formData = new FormData();

//   formData.append('file', file);

//   return http.post('/singleUpload', formData, {
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     }
//   });
// };

const uploadFile = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/singleUpload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const uploadBankReceipt = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/saveReceipt', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const uploadExcel = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/upload_chr_employees', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const getFiles = () => {
  return http.get('/files');
};

const updatePass = (data) => {
  return axios.patch(API_URLU + 'changepwd', data, { headers: authHeader() });
};

const updateUser = (data) => {
  return axios.get(
    API_URLU + 'update-user-profile?id=' + data.id + '&longName=' + data.longName + '&email=' + data.email + '&phone=' + data.phone,
    { headers: authHeader() }
  );
};

const updateUserImg = (data) => {
  return axios.get(API_URLU + 'update-user-image?id=' + data.id + '&photoUrl=' + data.photoUrl, { headers: authHeader() });
};

const getStockCodes = (cmp_id) => {
  return axios.get(API_URLU + 'supplier-products/' + cmp_id, { headers: authHeader() });
};

const getCompanyProducts = (cmp_id) => {
  return axios.get(API_URLU + 'company-istproducts/' + cmp_id, { headers: authHeader() });
};

const getCompanySuppliers = (cmp_id) => {
  return axios.get(API_URLU + 'company-istsuppliers/' + cmp_id, { headers: authHeader() });
};

const getProductDetails = (id) => {
  return axios.get(API_URLU + 'ist-products/' + id, { headers: authHeader() });
};

const getSupplierDetails = (id) => {
  return axios.get(API_URLU + 'ist-suppliers/' + id, { headers: authHeader() });
};

const getSupplerProductDetails = (id) => {
  return axios.get(API_URLU + 'ist-supplierProducts/' + id, { headers: authHeader() });
};

const getSupplierStocks = (supCode) => {
  return axios.get(API_URLU + 'company-istsupplierProducts/' + supCode, { headers: authHeader() });
};

const getCompanyStockCodes = (cmpId) => {
  return axios.get(API_URLU + 'company-stockcodes/' + cmpId, { headers: authHeader() });
};

const getCompanyStocks = (cmpId) => {
  return axios.get(API_URLU + 'company-stocks/' + cmpId, { headers: authHeader() });
};

const getQuoteId = (stockCode, pdate, cmpId, puser, cname, cphone, caddress, qtdId, quant) => {
  return axios.get(
    API_URLU +
      'qtn_id?stockCode=' +
      stockCode +
      '&pdate=' +
      pdate +
      '&cmpId=' +
      cmpId +
      '&puser=' +
      puser +
      '&clientName=' +
      cname +
      '&clientPhone=' +
      cphone +
      '&clientAddress=' +
      caddress +
      '&qtdId=' +
      qtdId +
      '&quantity=' +
      quant,
    { headers: authHeader() }
  );
};

const genCombinedQuote = (qhdId, cmpId, pdate, puser) => {
  return axios.get(API_URLU + 'gen-combinedQuote?qhdId=' + qhdId + '&cmpId=' + cmpId + '&pdate=' + pdate + '&user=' + puser, {
    headers: authHeader()
  });
};

const updateStockQuote = (stockCode, pdate, cmpId, puser) => {
  return axios.get(API_URLU + 'update-quote?stockCode=' + stockCode + '&pdate=' + pdate + '&cmpId=' + cmpId + '&user=' + puser, {
    headers: authHeader()
  });
};

const updatePriceList = (stockCode, pdate, cmpId) => {
  return axios.get(API_URLU + 'update-price?stockCode=' + stockCode + '&effDate=' + pdate + '&cmpId=' + cmpId, {
    headers: authHeader()
  });
};

const UpdateAllPrices = (pdate, cmpId) => {
  return axios.get(API_URLU + 'update-price-all?effDate=' + pdate + '&cmpId=' + cmpId, {
    headers: authHeader()
  });
};

const inteGrateWithKct = (cmpId) => {
  return axios.get(API_URLU + 'integrate-with-kct?cmpId=' + cmpId, {
    headers: authHeader()
  });
};

const getQuoteReport = (
  quoteId,
  repFormat,
  companyName,
  clientName,
  clientPhone,
  clientAddress,
  code,
  sname,
  dateOfQuote,
  repName,
  quantity,
  totalCashPrice,
  phyLocation,
  postalAddress,
  town,
  telephone,
  quoteIdz
) => {
  return axios.get(
    API_URLU +
      'pricequote-report?qtnId=' +
      quoteId +
      '&reportFormat=' +
      repFormat +
      '&companyName=' +
      companyName +
      '&clientName=' +
      clientName +
      '&clientPhone=' +
      clientPhone +
      '&clientAddress=' +
      clientAddress +
      '&stockCode=' +
      code +
      '&stockName=' +
      sname +
      '&quoteDate=' +
      dateOfQuote +
      '&repName=' +
      repName +
      '&quantity=' +
      quantity +
      '&totalCashPrice=' +
      totalCashPrice +
      '&phyLocation=' +
      phyLocation +
      '&postalAddress=' +
      postalAddress +
      '&town=' +
      town +
      '&telephone=' +
      telephone +
      '&nonStockCode=' +
      quoteIdz,
    { headers: authHeader() }
  );
};

const getCombQuoteReport = (
  quoteId,
  repFormat,
  companyName,
  clientName,
  clientPhone,
  clientAddress,
  code,
  sname,
  dateOfQuote,
  repName,
  quantity,
  totalCashPrice,
  phyLocation,
  postalAddress,
  town,
  telephone,
  quoteIdz
) => {
  return axios.get(
    API_URLU +
      'pricequote-report?qtnId=' +
      quoteId +
      '&reportFormat=' +
      repFormat +
      '&companyName=' +
      companyName +
      '&clientName=' +
      clientName +
      '&clientPhone=' +
      clientPhone +
      '&clientAddress=' +
      clientAddress +
      '&stockCode=' +
      code +
      '&stockName=' +
      sname +
      '&quoteDate=' +
      dateOfQuote +
      '&repName=' +
      repName +
      '&quantity=' +
      quantity +
      '&totalCashPrice=' +
      totalCashPrice +
      '&phyLocation=' +
      phyLocation +
      '&postalAddress=' +
      postalAddress +
      '&town=' +
      town +
      '&telephone=' +
      telephone +
      '&nonStockCode=' +
      quoteIdz,
    { headers: authHeader() }
  );
};

const getQuoteInfo = (id) => {
  return axios.get(API_URLU + 'price-quotation/' + id, { headers: authHeader() });
};
const delQuote = (user, id) => {
  return axios.get(API_URLU + 'archive-quote?user=' + user + '&qtnId=' + id, { headers: authHeader() });
};

const closePeriod = (id) => {
  return axios.get(API_URLU + 'close-period?periodId=' + id, { headers: authHeader() });
};

const archCombQuote = (user, id) => {
  return axios.get(API_URLU + 'archive-combQuote?user=' + user + '&qhdId=' + id, { headers: authHeader() });
};

const postQuoteHeader = (data) => {
  return axios.post(API_URLU + 'combined-quotation', data, { headers: authHeader() });
};

const postQuoteDetails = (data) => {
  return axios.post(API_URLU + 'quote-details', data, { headers: authHeader() });
};

const postVatRates = (data) => {
  return axios.post(API_URLU + 'vat-rates', data, { headers: authHeader() });
};

const postStandardRates = (data) => {
  return axios.post(API_URLU + 'standard-rates', data, { headers: authHeader() });
};

const postNewPeriod = (data) => {
  return axios.post(API_URLU + 'ist-periods', data, { headers: authHeader() });
};

const postGeneralRates = (data) => {
  return axios.post(API_URLU + 'general-rates', data, { headers: authHeader() });
};

const postIstProducts = (data) => {
  return axios.post(API_URLU + 'ist-products', data, { headers: authHeader() });
};

const postIstSuppliers = (data) => {
  return axios.post(API_URLU + 'ist-suppliers', data, { headers: authHeader() });
};

const putIstProducts = (id, data) => {
  return axios.put(API_URLU + 'ist-products/' + id, data, { headers: authHeader() });
};

const putIstSupplierProducts = (id, data) => {
  return axios.put(API_URLU + 'ist-supplierProducts/' + id, data, { headers: authHeader() });
};

const postIstSupplierProducts = (data) => {
  return axios.post(API_URLU + 'ist-supplierProducts', data, { headers: authHeader() });
};

const putCashRateDetails = (id, data) => {
  return axios.put(API_URLU + 'ist-cashRates/' + id, data, { headers: authHeader() });
};

const postCashRateDetails = (data) => {
  return axios.post(API_URLU + 'ist-cashRates', data, { headers: authHeader() });
};

const putHpDepositDetails = (id, data) => {
  return axios.put(API_URLU + 'ist-hpdepositPercs/' + id, data, { headers: authHeader() });
};

const postHpDepositDetails = (data) => {
  return axios.post(API_URLU + 'ist-hpdepositPercs', data, { headers: authHeader() });
};

const delHpDepositDetails = (id) => {
  return axios.delete(API_URLU + 'ist-hpdepositPercs/' + id, { headers: authHeader() });
};

const putMarkupDetails = (id, data) => {
  return axios.put(API_URLU + 'ist-checkOffMarkup/' + id, data, { headers: authHeader() });
};

const postMarkupDetails = (data) => {
  return axios.post(API_URLU + 'ist-checkOffMarkup', data, { headers: authHeader() });
};

const putDiscountDetails = (id, data) => {
  return axios.put(API_URLU + 'ist-hpdiscounts/' + id, data, { headers: authHeader() });
};

const postDiscountDetails = (data) => {
  return axios.post(API_URLU + 'ist-hpdiscounts', data, { headers: authHeader() });
};

const delDiscountDetails = (id) => {
  return axios.delete(API_URLU + 'ist-hpdiscounts/' + id, { headers: authHeader() });
};

const putInstalMonths = (id, data) => {
  return axios.put(API_URLU + 'ist-instalmonths/' + id, data, { headers: authHeader() });
};

const postInstalMonths = (data) => {
  return axios.post(API_URLU + 'ist-instalmonths', data, { headers: authHeader() });
};

const delInstalMonths = (id) => {
  return axios.delete(API_URLU + 'ist-instalmonths/' + id, { headers: authHeader() });
};

const putMarkupRates = (id, data) => {
  return axios.put(API_URLU + 'ist-hpmarkuprates/' + id, data, { headers: authHeader() });
};

const postMarkupRates = (data) => {
  return axios.post(API_URLU + 'ist-hpmarkuprates', data, { headers: authHeader() });
};

const delMarkupRate = (id) => {
  return axios.delete(API_URLU + 'ist-hpmarkuprates/' + id, { headers: authHeader() });
};

const putMarkupPercs = (id, data) => {
  return axios.put(API_URLU + 'ist-hpmarkuppercs/' + id, data, { headers: authHeader() });
};

const getCombinedQuotes = (qdtId) => {
  return axios.get(API_URLU + 'get-combinedQuotes/' + qdtId, { headers: authHeader() });
};

const listSingleQuoutes = () => {
  return axios.get(API_URLU + 'list-singleQuotes', { headers: authHeader() });
};

const listCombinedQuoutes = (cmpId) => {
  return axios.get(API_URLU + 'list-combinedQuotes/' + cmpId, { headers: authHeader() });
};

const companyVatRates = (cmpId) => {
  return axios.get(API_URLU + 'company-vats/' + cmpId, { headers: authHeader() });
};

const companyStdRates = (cmpId) => {
  return axios.get(API_URLU + 'company-standardRates/' + cmpId, { headers: authHeader() });
};

const companyGenRates = (cmpId) => {
  return axios.get(API_URLU + 'company-generalRates/' + cmpId, { headers: authHeader() });
};
const currentPeriods = (cmpId) => {
  return axios.get(API_URLU + 'company-currentperiods/' + cmpId, { headers: authHeader() });
};
const pastPeriods = (cmpId) => {
  return axios.get(API_URLU + 'company-pastperiods/' + cmpId, { headers: authHeader() });
};

const allPeriods = (cmpId) => {
  return axios.get(API_URLU + 'get-periods-vw?cmpId=' + cmpId, { headers: authHeader() });
};

const checkVatDates = (cmpId, startDate, endDate) => {
  return axios.get(API_URLU + 'check-vatDates?cmpId=' + cmpId + '&startDate=' + startDate + '&endDate=' + endDate, {
    headers: authHeader()
  });
};

const getCombinedSingle = (stockCode) => {
  return axios.get(API_URLU + 'combined-single?stockCode=' + stockCode, { headers: authHeader() });
};

const getCompanyTariffPeriods = (cmpId) => {
  return axios.get(API_URLU + 'tariff-periods?cmpId=' + cmpId, { headers: authHeader() });
};

const getTariffCashRates = (trpId) => {
  return axios.get(API_URLU + 'ist-trpCashRates/' + trpId, { headers: authHeader() });
};

const getCheckOffMarkupPercs = (trpId) => {
  return axios.get(API_URLU + 'ist-companyCheckOffMarkup/' + trpId, { headers: authHeader() });
};

const getTrpDiscounts = (trpId) => {
  return axios.get(API_URLU + 'ist-hpTrpdiscounts/' + trpId, { headers: authHeader() });
};

const getTrpInstalMonths = (trpId) => {
  return axios.get(API_URLU + 'ist-trpinstalmonths/' + trpId, { headers: authHeader() });
};

const getHpMarkupRates = (trpId) => {
  return axios.get(API_URLU + 'ist-trphpmarkuprates/' + trpId, { headers: authHeader() });
};

const getHpMarkupPercs = (trpId) => {
  return axios.get(API_URLU + 'ist-trphpmarkuppercs/' + trpId, { headers: authHeader() });
};

const getDiscountDetails = (id) => {
  return axios.get(API_URLU + 'ist-hpdiscounts/' + id, { headers: authHeader() });
};

const getInstalMonthsDetails = (id) => {
  return axios.get(API_URLU + 'ist-instalmonths/' + id, { headers: authHeader() });
};

const getRateDetails = (id) => {
  return axios.get(API_URLU + 'ist-cashRates/' + id, { headers: authHeader() });
};

const getHPDepositDetails = (id) => {
  return axios.get(API_URLU + 'ist-hpdepositPercs/' + id, { headers: authHeader() });
};

const getMarkupPercDetails = (id) => {
  return axios.get(API_URLU + 'ist-checkOffMarkup/' + id, { headers: authHeader() });
};

const closeTariffPeriod = (cmpId, pdate, user) => {
  return axios.get(API_URLU + 'close-tariffperiod?cmpId=' + cmpId + '&pdate=' + pdate + '&user=' + user, { headers: authHeader() });
};

const getTrpHpDeposit = (trpId) => {
  return axios.get(API_URLU + 'ist-hpTrpdepositPercs/' + trpId, { headers: authHeader() });
};

const getMarkupDetails = (rateId) => {
  return axios.get(API_URLU + 'ist-hpmarkuprates/' + rateId, { headers: authHeader() });
};

const getMarkupPerc = (rateId) => {
  return axios.get(API_URLU + 'ist-hpmarkuppercs/' + rateId, { headers: authHeader() });
};

const copyPeriods = (cmpId, trpId, pUser, pDate) => {
  return axios.get(API_URLU + 'copy-periods?cmpId=' + cmpId + '&trpId=' + trpId + '&pUser=' + pUser + '&pDate=' + pDate, {
    headers: authHeader()
  });
};

const getProductHist = (id) => {
  return axios.get(API_URLU + 'ist-productsHist/' + id, { headers: authHeader() });
};

const getPriceCataloq = (periodY) => {
  return axios.get(API_URLU + 'get-price-catalogue?periodYear=' + periodY, { headers: authHeader() });
};

const getStockCatalogue = (stockCode) => {
  return axios.get(API_URLU + 'get-stock-catalog?stockCode=' + stockCode, { headers: authHeader() });
};

const getCataloguePeriods = () => {
  return axios.get(API_URLU + 'get-catalog-periods', { headers: authHeader() });
};

const getJointYn = (stockCode, cmpId) => {
  return axios.get(API_URLU + 'is-jointStock?stockCode=' + stockCode + '&cmpId=' + cmpId, { headers: authHeader() });
};

const getJointStockCodes = (stockCode, cmpId) => {
  return axios.get(API_URLU + 'joint-stocks?stockCode=' + stockCode + '&cmpId=' + cmpId, { headers: authHeader() });
};

const getActiveStocks = (cmpId, pDate) => {
  return axios.get(API_URLU + 'active-stocks?cmpId=' + cmpId + '&pDate=' + pDate, { headers: authHeader() });
};

const getJointStocks = (cmpId, pDate, stockCode) => {
  return axios.get(API_URLU + 'attach-joint-stocks?cmpId=' + cmpId + '&pDate=' + pDate + '&stockCode=' + stockCode, {
    headers: authHeader()
  });
};

const addJointStocks = (cmpId, jointStockCode, stockCode, pAction) => {
  return axios.get(
    API_URLU + 'add-joint-stock?cmpId=' + cmpId + '&jointStockCode=' + jointStockCode + '&stockCode=' + stockCode + '&pAction=' + pAction,
    { headers: authHeader() }
  );
};

const getMinDate = (cmpId) => {
  return axios.get(API_URLU + 'min-date?cmpId=' + cmpId, { headers: authHeader() });
};

const getStockCheckOff = (stockCode) => {
  return axios.get(API_URLU + 'stock-checkoff?stockCode=' + stockCode, { headers: authHeader() });
};

const getSupplierPriceList = (cmpId, supCode) => {
  return axios.get(API_URLU + 'supplier-price-list?cmpId=' + cmpId + '&supCode=' + supCode, { headers: authHeader() });
};

const getSupplierPastPriceList = (cmpId, supCode, stockCode) => {
  return axios.get(API_URLU + 'supplier-pastprice-list?cmpId=' + cmpId + '&supCode=' + supCode + '&stockCode=' + stockCode, {
    headers: authHeader()
  });
};

const updatePriceCatalogue = (data) => {
  return axios.get(
    API_URLU +
      'update-price-catalogue?periodYear=' +
      data.periodYear +
      '&periodMonth=' +
      data.periodMonth +
      '&pDate=' +
      data.pDate +
      '&cmpId=' +
      data.cmpId +
      '&username=' +
      data.username,
    {
      headers: authHeader()
    }
  );
};

const addNewPriceListItem = (data) => {
  return axios.get(
    API_URLU +
      'add-new-stock-pricelist?cmpId=' +
      data.cmpId +
      '&stockCode=' +
      data.stockCode +
      '&pDate=' +
      data.pDate +
      '&combinedSingle=' +
      data.combinedSingle +
      '&pUser=' +
      data.pUser,
    {
      headers: authHeader()
    }
  );
};

const getUserRights = (data) => {
  return axios.get(API_URLU + 'userRights?sstId=' + data.sstId + '&username=' + data.username, {
    headers: authHeader()
  });
};

const approveVATRates = (data) => {
  return axios.get(
    API_URLU +
      'approve-vat?approvedYN=' +
      data.approvedYN +
      '&approvedBy=' +
      data.approvedBy +
      '&approvedDate=' +
      data.approvedDate +
      '&id=' +
      data.id,
    {
      headers: authHeader()
    }
  );
};

const approveSTDRates = (data) => {
  return axios.get(
    API_URLU +
      'approve-std?approvedYN=' +
      data.approvedYN +
      '&approvedBy=' +
      data.approvedBy +
      '&approvedDate=' +
      data.approvedDate +
      '&id=' +
      data.id,
    {
      headers: authHeader()
    }
  );
};

const approveGENRates = (data) => {
  return axios.get(
    API_URLU +
      'approve-gen?approvedYN=' +
      data.approvedYN +
      '&approvedBy=' +
      data.approvedBy +
      '&approvedDate=' +
      data.approvedDate +
      '&id=' +
      data.id,
    {
      headers: authHeader()
    }
  );
};

const approvePeriod = (data) => {
  return axios.get(
    API_URLU +
      'approve-period?approvedYN=' +
      data.approvedYN +
      '&approvedBy=' +
      data.approvedBy +
      '&approvedDate=' +
      data.approvedDate +
      '&id=' +
      data.id,
    {
      headers: authHeader()
    }
  );
};

const approveStock = (data) => {
  return axios.get(
    API_URLU +
      'approve-stock?approvedYN=' +
      data.approvedYN +
      '&approvedBy=' +
      data.approvedBy +
      '&approvedDate=' +
      data.approvedDate +
      '&id=' +
      data.id +
      '&cmpId=' +
      data.cmpId,
    {
      headers: authHeader()
    }
  );
};

const clearStockPrices = (data) => {
  return axios.get(API_URLU + 'clear-stock-prices?periodYear=' + data.periodY + '&periodMonth=' + data.periodM, {
    headers: authHeader()
  });
};

const updateStockPrices = (data) => {
  return axios.get(API_URLU + 'update-stock-prices?cmpId=' + data.cmpId + '&periodYear=' + data.periodY + '&periodMonth=' + data.periodM, {
    headers: authHeader()
  });
};

const updateTariffPeriod = (data) => {
  return axios.get(API_URLU + 'update-tariff-period?id=' + data.id + '&startdate=' + data.startdate + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const approvetariffPeriod = (data) => {
  return axios.get(API_URLU + 'approve-tariff-period-proc?id=' + data.id + '&username=' + data.username + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const approveCashRate = (data) => {
  return axios.get(API_URLU + 'approve-cashrate?rateId=' + data.id + '&pUser=' + data.username, {
    headers: authHeader()
  });
};

const approveCheckOff = (data) => {
  return axios.get(API_URLU + 'approve-checkoff?rateId=' + data.id + '&pUser=' + data.username, {
    headers: authHeader()
  });
};

const genCombQuoteHeader = (data) => {
  return axios.get(
    API_URLU +
      'gen-comb-non-stock-header?cmpId=' +
      data.cmpId +
      '&supName=' +
      data.supName +
      '&user=' +
      data.user +
      '&quoteDate=' +
      data.quoteDate +
      '&weight=' +
      data.weight +
      '&solarPanel=' +
      data.solarPanel +
      '&solarComponent=' +
      data.solarComponent +
      '&discountPerc=' +
      data.discountPerc +
      '&stockName=' +
      data.stockName,
    {
      headers: authHeader()
    }
  );
};
const genCombQuoteNoneStockDetails = (data) => {
  return axios.get(
    API_URLU +
      'gen-comb-non-stock-details?cmpId=' +
      data.cmpId +
      '&csqId=' +
      data.csqId +
      '&stockName=' +
      data.stockName +
      '&supplierPrice=' +
      data.supplierPrice +
      '&vatableYn=' +
      data.vatableYn +
      '&vatRate=' +
      data.vatRate +
      '&createdBy=' +
      data.createdBy,
    {
      headers: authHeader()
    }
  );
};
const genNoneStockQuote = (data) => {
  return axios.get(
    API_URLU +
      'none-stock-quote?stockName=' +
      data.stockName +
      '&supplierName=' +
      data.supplierName +
      '&weight=' +
      data.weight +
      '&supplierPrice=' +
      data.supplierPrice +
      '&saleVatRate=' +
      data.saleVatRate +
      '&discountPerc=' +
      data.discountPerc +
      '&solarPanelYn=' +
      data.solarPanelYn +
      '&solarComponentYn=' +
      data.solarComponentYn +
      '&pDate=' +
      data.pDate +
      '&cmpId=' +
      data.cmpId +
      '&username=' +
      data.username,
    {
      headers: authHeader()
    }
  );
};

const genCombNoneStockQuote = (data) => {
  return axios.get(
    API_URLU +
      'gen-comb-non-stock-quote?stockName=' +
      data.stockName +
      '&supplierName=' +
      data.supplierName +
      '&weight=' +
      data.weight +
      '&supplierPrice=' +
      data.supplierPrice +
      '&saleVatRate=' +
      data.saleVatRate +
      '&discountPerc=' +
      data.discountPerc +
      '&solarPanelYn=' +
      data.solarPanelYn +
      '&solarComponentYn=' +
      data.solarComponentYn +
      '&pDate=' +
      data.pDate +
      '&cmpId=' +
      data.cmpId +
      '&username=' +
      data.username +
      '&csqId=' +
      data.csqId,
    {
      headers: authHeader()
    }
  );
};

const listNonStockQuotes = (id) => {
  return axios.get(API_URLU + 'get-none-stock-quotes?nonStockCode=' + id, { headers: authHeader() });
};

const listCombNonStockQuotes = (id) => {
  return axios.get(API_URLU + 'get-comb-none-stock-quotes?csqId=' + id, { headers: authHeader() });
};

const getActiveEndDate = (cmpId) => {
  return axios.get(API_URLU + 'active_enddate?cmpId=' + cmpId, { headers: authHeader() });
};

const getMenuLevels = (data) => {
  return axios.get(API_URLU + 'get-menusbk?sstId=' + data.sstId + '&accessId=' + data.accessId + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getAddTempItem = (id) => {
  return axios.get(API_URLU + 'add-temp-stock?stockCode=' + id, {
    headers: authHeader()
  });
};

const getPoH = () => {
  return axios.get(API_URLU + 'po-headers', { headers: authHeader() });
};

const getPoHVW = (data) => {
  return axios.get(API_URLU + 'po-headervw?cmpId=' + data.cmpId + '&userId=' + data.userId + '&approvalStatus=' + data.approvalStatus, {
    headers: authHeader()
  });
};

const getPoHBalnce = (data) => {
  return axios.get(API_URLU + 'po-balance?cmpId=' + data.cmpId + '&userId=' + data.userId + '&supplierCode=' + data.supplierCode, {
    headers: authHeader()
  });
};

const getReqH = (data) => {
  return axios.get(API_URLU + 'req-headersvw?userId=' + data.userId + '&cmpId=' + data.cmpId, { headers: authHeader() });
};

const getPoD = (id) => {
  return axios.get(API_URLU + 'po-details-vw?phdId=' + id, { headers: authHeader() });
};

const getReqD = (id) => {
  return axios.get(API_URLU + 'req-details-vw?rqhId=' + id, { headers: authHeader() });
};

const getPolNo = (data) => {
  return axios.get(
    API_URLU +
      'getPolnumber?cmpId=' +
      data.cmpId +
      '&transType=' +
      data.transType +
      '&branchCode=' +
      data.branchCode +
      '&transDate=' +
      data.transDate,
    { headers: authHeader() }
  );
};

const postPoH = (data) => {
  return axios.post(API_URLU + 'po-headers', data, { headers: authHeader() });
};

const postPoD = (data) => {
  return axios.post(API_URLU + 'po-details', data, { headers: authHeader() });
};

const getReqSummary = (data) => {
  return axios.get(API_URLU + 'requisition-summary/' + data.year + '/' + data.usrId, { headers: authHeader() });
};

const getPoSummary = (data) => {
  return axios.get(API_URLU + 'po-summary/' + data.year + '/' + data.usrId, { headers: authHeader() });
};

const getPohApproval = (data) => {
  return axios.get(
    API_URLU +
      'approve-poh?username=' +
      data.username +
      '&approvedDate=' +
      data.approvedDate +
      '&phdId=' +
      data.phdId +
      '&cmpId=' +
      data.cmpId +
      '&approvalStatus=' +
      data.approvalStatus,
    { headers: authHeader() }
  );
};

const updateMialSent = (data) => {
  return axios.get(API_URLU + 'approve-poh-mail?phdId=' + data.phdId + '&cmpId=' + data.cmpId, { headers: authHeader() });
};

const cancelPO = (data) => {
  return axios.get(
    API_URLU +
      'cancel-poh?phdId=' +
      data.phdId +
      '&cmpId=' +
      data.cmpId +
      '&cancellationReason=' +
      data.cancellationReason +
      '&username=' +
      data.username +
      '&cancelledDate=' +
      data.cancelledDate,
    { headers: authHeader() }
  );
};

const getPurchaseReport = (data) => {
  return axios.get(
    API_URLU +
      'purchase-report?reportFormat=' +
      data.reportFormat +
      '&repName=' +
      data.repName +
      '&cmpId=' +
      data.cmpId +
      '&phdId=' +
      data.phdId +
      '&approvedBy=' +
      data.approvedBy +
      '&vendor=' +
      data.vendor +
      '&poNumber=' +
      data.poNumber +
      '&poDate=' +
      data.poDate +
      '&shop=' +
      data.shop +
      '&dispatchCode=' +
      data.dispatchCode +
      '&signUrl=' +
      data.signUrl +
      '&oldOrderNumber=' +
      data.oldOrderNumber,
    {
      headers: authHeader()
    }
  );
};

const getCertReport = (data) => {
  return axios.get(
    API_URLU +
      'purchase-report?reportFormat=' +
      data.reportFormat +
      '&repName=' +
      data.repName +
      '&cmpId=' +
      data.cmpId +
      '&custCode=' +
      data.custCode +
      '&hpId=' +
      data.hpId +
      '&currDate=' +
      data.currDate,
    {
      headers: authHeader()
    }
  );
};

const postGaaH = (data) => {
  return axios.post(API_URLU + 'gaa-headers', data, { headers: authHeader() });
};

const postGaaD = (data) => {
  return axios.post(API_URLU + 'gaa-details', data, { headers: authHeader() });
};

const getGaaDByGaaNo = (id) => {
  return axios.get(API_URLU + 'gaa-details-gaaNo?gaaNo=' + id, { headers: authHeader() });
};

const getUpdatePoDetails = (data) => {
  return axios.get(
    API_URLU +
      'approve-pod?rqdId=' +
      data.rqdId +
      '&cmpId=' +
      data.cmpId +
      '&quantityApproved=' +
      data.quantityApproved +
      '&approvalComments=' +
      data.approvalComments +
      '&approvalStatus=' +
      data.approvalStatus +
      '&username=' +
      data.username +
      '&approvedDate=' +
      data.approvedDate,
    {
      headers: authHeader()
    }
  );
};

const getPoNotInGaa = (data) => {
  return axios.get(
    API_URLU + 'po-notin-gaa-headervw?cmpId=' + data.cmpId + '&userId=' + data.userId + '&approvalStatus=' + data.approvalStatus,
    {
      headers: authHeader()
    }
  );
};

const getGaaHVW = (data) => {
  return axios.get(API_URLU + 'gaa-headervw?cmpId=' + data.cmpId + '&userId=' + data.userId, {
    headers: authHeader()
  });
};

const getGaaHVWItems = (data) => {
  return axios.get(API_URLU + 'gaa-headervw-items?cmpId=' + data.cmpId + '&userId=' + data.userId + '&poNumber=' + data.poNumber, {
    headers: authHeader()
  });
};

const getUserBranches = (id, id2) => {
  return axios.get(API_URLU + 'get-user_branches?cmpId=' + id + '&userId=' + id2, {
    headers: authHeader()
  });
};

const postGap = (data) => {
  return axios.post(API_URLU + 'gaa-particulars', data, { headers: authHeader() });
};

const getGapItemsByGaaNo = (id) => {
  return axios.get(API_URLU + 'gaa-particulars-gaaNo?gaaNo=' + id, { headers: authHeader() });
};

const postStkTransH = (data) => {
  return axios.post(API_URLU + 'stock-trans-header', data, { headers: authHeader() });
};

const postStkTransD = (data) => {
  return axios.post(API_URLU + 'stock-trans-details', data, { headers: authHeader() });
};

const generateCombinedNonStockQuote = (csqId, user) => {
  return axios.get(API_URLU + 'generate-combined-nonstock-quote?csqId=' + csqId + '&user=' + user, { headers: authHeader() });
};

const getShopTransfers = (data) => {
  return axios.get(
    API_URLU + 'shop-trans-headervw?cmpId=' + data.cmpId + '&userId=' + data.userId + '&approvalStatus=' + data.approvalStatus,
    {
      headers: authHeader()
    }
  );
};

const getShopTransferDetails = (data) => {
  return axios.get(API_URLU + 'shop-trans-detailvw?cmpId=' + data.cmpId + '&sthId=' + data.sthId, {
    headers: authHeader()
  });
};

const getTransferInvoiceReport = (data) => {
  return axios.get(
    API_URLU +
      'transfer-invoice-report?reportFormat=' +
      data.reportFormat +
      '&repName=' +
      data.repName +
      '&cmpId=' +
      data.cmpId +
      '&phdId=' +
      data.phdId +
      '&approvedBy=' +
      data.approvedBy +
      '&vendor=' +
      data.vendor +
      '&poNumber=' +
      data.poNumber +
      '&poDate=' +
      data.poDate +
      '&shop=' +
      data.shop +
      '&Collected_by=' +
      data.Collected_by +
      '&Dispatcher=' +
      data.Dispatcher +
      '&url=' +
      data.url +
      '&oldOrderNumber=' +
      data.oldOrderNumber,
    {
      headers: authHeader()
    }
  );
};

const getSupplierEmail = (data) => {
  return axios.get(API_URLU + 'supplier-emails?supplierCode=' + data.supplierCode + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const sendLpoMail = (data) => {
  return axios.get(API_URLU + 'send-lpo-email?email=' + data.email + '&repName=' + data.repName, {
    headers: authHeader()
  });
};

const saleItems = (data) => {
  return axios.get(API_URLU + 'get-sale-items?cmpId=' + data.cmpId + '&branchCode=' + data.branchCode, {
    headers: authHeader()
  });
};

const postSalesHeader = (data) => {
  return axios.post(API_URLU + 'sale-header', data, { headers: authHeader() });
};

const postSalesDetails = (data) => {
  return axios.post(API_URLU + 'sale-details', data, { headers: authHeader() });
};

const getSalesDetailsBySshId = (id) => {
  return axios.get(API_URLU + 'sale-details-ssh?sshId=' + id, { headers: authHeader() });
};

const postSalesParticular = (data) => {
  return axios.post(API_URLU + 'sale-particulars', data, { headers: authHeader() });
};

const getSalesParticularBySshId = (id) => {
  return axios.get(API_URLU + 'sale-particulars-ssh?sshId=' + id, { headers: authHeader() });
};

const getSalesHeader = (id) => {
  return axios.get(API_URLU + 'cmp-sale-header?cmpId=' + id, { headers: authHeader() });
};

const getHPSalesHeader = (id) => {
  return axios.get(API_URLU + 'hp-sales-cmpid?cmpId=' + id, { headers: authHeader() });
};

const getHPPreSalesHeader = (id) => {
  return axios.get(API_URLU + 'hp-prepost-sales?cmpId=' + id, { headers: authHeader() });
};

const getReceiptTranCodes = (cmpId) => {
  return axios.get(API_URLU + 'receipt-codes/' + cmpId, { headers: authHeader() });
};

const findPaymentModes = () => {
  return axios.get(API_URLU + 'payment-modes', { headers: authHeader() });
};

const getCustomerCodes = (cmpId) => {
  return axios.get(API_URLU + 'customer-codes/' + cmpId, { headers: authHeader() });
};

const getPolicyInformation = (custCode) => {
  return axios.get(API_URLU + 'policy-information/' + custCode, { headers: authHeader() });
};

const getSaleInformation = (data) => {
  return axios.get(API_URLU + 'sale-information/' + data.cmpId + '/' + data.branchCode + '/' + data.custCode + '/' + data.saleType, {
    headers: authHeader()
  });
};

const getAddress = (clientNumber) => {
  return axios.get(API_URLU + 'client-address/' + clientNumber, { headers: authHeader() });
};

const getAllBankAccounts = (cmpId) => {
  return axios.get(API_URLU + 'company-accounts/' + cmpId, { headers: authHeader() });
};

const getAllCreditAccounts = (cmpId) => {
  return axios.get(API_URLU + 'credit-accounts/' + cmpId, { headers: authHeader() });
};

const getLinkedCustomerAccounts = (cmpId, custCode) => {
  return axios.get(API_URLU + 'linked-customer-accounts/' + cmpId + '/' + custCode, { headers: authHeader() });
};

const getCustomerSubaccounts = (cmpId, custCode) => {
  return axios.get(API_URLU + 'get-customer-subaccount/' + cmpId + '/' + custCode, { headers: authHeader() });
};

const getDocDetails = (cmpId, tranCode, docDate, auto) => {
  return axios.get(API_URLU + 'doc_number?cmpId=' + cmpId + '&trancode=' + tranCode + '&docdate=' + docDate + '&auto=' + auto, {
    headers: authHeader()
  });
};

const docAvailable = (data) => {
  return axios.get(
    API_URLU +
      'is-doc-number-available?accountYear=' +
      data.accountYear +
      '&tranCode=' +
      data.tranCode +
      '&docNumber=' +
      data.docNumber +
      '&cmpId=' +
      data.cmpId,
    { headers: authHeader() }
  );
};

const postReceiptHeader = (data) => {
  return axios.post(API_URLU + 'receipt', data, { headers: authHeader() });
};

const putReceiptHeader = (id, data) => {
  return axios.put(API_URLU + 'receipt/' + id, data, { headers: authHeader() });
};

const getReceiptHeader = (id) => {
  return axios.get(API_URLU + 'receipt/' + id, { headers: authHeader() });
};

const postReceiptDetails = (data) => {
  return axios.post(API_URLU + 'receipt-details', data, { headers: authHeader() });
};

const putReceiptDetails = (id, data) => {
  return axios.put(API_URLU + 'receipt-details/' + id, data, { headers: authHeader() });
};

const getReceiptDetails = (id) => {
  return axios.get(API_URLU + 'receipt-details/' + id, { headers: authHeader() });
};

const deleteReceiptDetail = (id) => {
  return axios.delete(API_URLU + 'receipt-details/' + id, { headers: authHeader() });
};

const getCompanyBanks = (cmpId) => {
  return axios.get(API_URLU + 'customer-banks/' + cmpId, { headers: authHeader() });
};

const getReceiptHeaderApprovalStatus = (cmpId, rhdId) => {
  return axios.get(API_URLU + 'is-header-approved/' + cmpId + '/' + rhdId, { headers: authHeader() });
};

const approveReceiptHeader = (cmpId, rhdId, docDate) => {
  return axios.get(API_URLU + 'approve-receipt-header/' + cmpId + '/' + rhdId + '/' + docDate, { headers: authHeader() });
};

const poReports = (id) => {
  return axios.get(API_URLU + 'po-reports?cmpId=' + id, { headers: authHeader() });
};

const getPoReportDetails = (data) => {
  return axios.get(
    API_URLU + 'po-report-details?cmpId=' + data.cmpId + '&userId=' + data.userId + '&approvalStatus=' + data.approvalStatus,
    {
      headers: authHeader()
    }
  );
};

const getPoReportDetailsByPhd = (data) => {
  return axios.get(
    API_URLU +
      'po-details-byphd?cmpId=' +
      data.cmpId +
      '&userId=' +
      data.userId +
      '&approvalStatus=' +
      data.approvalStatus +
      '&phdId=' +
      data.phdId,
    {
      headers: authHeader()
    }
  );
};

const getPurchaseReport2 = (data) => {
  return axios.get(
    API_URLU +
      'purchase-report?reportFormat=' +
      data.reportFormat +
      '&repName=' +
      data.repName +
      '&cmpId=' +
      data.cmpId +
      '&userId=' +
      data.userId,
    {
      headers: authHeader()
    }
  );
};

const getSaleTypes = (id) => {
  return axios.get(API_URLU + 'get-sale-type?cmpId=' + id, {
    headers: authHeader()
  });
};

const companyReceipts = (cmpId) => {
  return axios.get(API_URLU + 'get-company-receipts/' + cmpId, { headers: authHeader() });
};

const getSelectedReceiptDetails = (id) => {
  return axios.get(API_URLU + 'get-receipt-by-rhdid/' + id, { headers: authHeader() });
};

const getPaymentHeaders = () => {
  return axios.get(API_URLU + 'cfspaymentheaders-vw', { headers: authHeader() });
};

const getPaymentDetails = () => {
  return axios.get(API_URLU + 'payment-details', { headers: authHeader() });
};

const getPaymentHeaderByHeaderId = (phdId) => {
  return axios.get(API_URLU + 'payment-headers/' + phdId, {
    headers: authHeader()
  });
};

const getAllPaymentHeaders = () => {
  return axios.get(API_URLU + 'payment-headers', { headers: authHeader() });
};

const postPaymentHeaders = (data) => {
  return axios.post(API_URLU + 'payment-headers', data, { headers: authHeader() });
};

const postGltranHeaders = (data) => {
  return axios.post(API_URLU + 'gltran-headers', data, { headers: authHeader() });
};

const postGltranDetails = (data) => {
  return axios.post(API_URLU + 'gltran-details', data, { headers: authHeader() });
};

const putPaymentHeaders = (phdId, data) => {
  return axios.put(API_URLU + 'payment-headers/' + phdId, data, { headers: authHeader() });
};

const postPaymentDetails = (data) => {
  return axios.post(API_URLU + 'payment-details', data, { headers: authHeader() });
};

const postPaymentParticulars = (data) => {
  return axios.post(API_URLU + 'payment-particulars', data, { headers: authHeader() });
};

const deletePaymentDetails = (data) => {
  return axios.delete(API_URLU + 'payment-details?phdId=' + data.phdId + '&cmpId=' + data.cmpId, { headers: authHeader() });
};

const getInvoiceHeaders = () => {
  return axios.get(API_URLU + 'cfsinvoiceheaders-vw', { headers: authHeader() });
};

const getPaymentDetailsByHeaderId = (data) => {
  return axios.get(API_URLU + 'payment-details_vw?phdId=' + data.phdId + '&userId=' + data.userId + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getInvoiceTransactionCodes = () => {
  return axios.get(API_URLU + 'cfsinvoice-codes', { headers: authHeader() });
};

const getPaymentTransactionCodes = () => {
  return axios.get(API_URLU + 'cfspayment-codes', { headers: authHeader() });
};

const getPaymentModes = () => {
  return axios.get(API_URLU + 'cfspayment-modes', { headers: authHeader() });
};

const getOurRef = () => {
  return axios.get(API_URLU + 'cfspayments-ourref', { headers: authHeader() });
};

const getMainAccounts = () => {
  return axios.get(API_URLU + 'cfsmain-acc', { headers: authHeader() });
};

const getSubAccountsByMain = (data) => {
  return axios.get(API_URLU + 'cfssub-acc?accountCode=' + data.accountCode + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getCustBank = (data) => {
  return axios.get(API_URLU + 'cfs-custbanks?cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getBranches = () => {
  return axios.get(API_URLU + 'branch', { headers: authHeader() });
};

const getDepartments = () => {
  return axios.get(API_URLU + 'get-departments', { headers: authHeader() });
};

const getPaymentReport = (data) => {
  return axios.get(
    API_URLU +
      'purchase-report?reportFormat=' +
      data.reportFormat +
      '&repName=' +
      data.repName +
      '&cmpId=' +
      data.cmpId +
      '&phdId=' +
      data.phdId,
    {
      headers: authHeader()
    }
  );
};

const approvePaymentHeader = (data) => {
  return axios.get(
    API_URLU +
      'approve-payment-header?invoicePhdId=' +
      data.invoicePhdId +
      '&phdID=' +
      data.phdID +
      '&docDate=' +
      data.docDate +
      '&cmpId=' +
      data.cmpId +
      '&user=' +
      data.user +
      '&tranCode=' +
      data.tranCode +
      '&lcAmount=' +
      data.lcAmount +
      '&action=' +
      data.action,
    { headers: authHeader() }
  );
};

const getPaymentDocNumber = (data) => {
  return axios.get(
    API_URLU +
      'get-payment-doc-number?cmpId=' +
      data.cmpId +
      '&tranCode=' +
      data.tranCode +
      '&docDate=' +
      data.docDate +
      '&accountYear=' +
      data.accountYear,
    { headers: authHeader() }
  );
};

const getInvoiceBalance = (data) => {
  return axios.get(API_URLU + 'get-invoice-balance?phdId=' + data.phdId, {
    headers: authHeader()
  });
};

const getTranTypes = (cmpId) => {
  return axios.get(API_URLU + 'get-tran-types?cmpId=' + cmpId, { headers: authHeader() });
};
const getSaleFinTrans = (data) => {
  return axios.get(API_URLU + 'cmp-sale-fin-trans?sshId=' + data.sshId + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const genSaleFinTrans = (data) => {
  return axios.get(
    API_URLU +
      'gen-sale-fin-trans?sshId=' +
      data.sshId +
      '&cmpId=' +
      data.cmpId +
      '&saleDate=' +
      data.saleDate +
      '&username=' +
      data.username,

    {
      headers: authHeader()
    }
  );
};

const postSaleFinGL = (data) => {
  return axios.get(
    API_URLU + 'post-sale-fin-trans?sshId=' + data.sshId + '&username=' + data.username,

    {
      headers: authHeader()
    }
  );
};

const linkCustomerAccount = (data) => {
  return axios.get(API_URLU + 'link-debtor-subaccount?custCode=' + data.custCode + '&user=' + data.user + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const generateCustomerSubaccount = (data) => {
  return axios.get(API_URLU + 'generate-customer-subaccout?cmpId=' + data.cmpId + '&custCode=' + data.custCode + '&user=' + data.user, {
    headers: authHeader()
  });
};

const getUnbankedReceipts = (cmpId, user) => {
  return axios.get(API_URLU + 'get-unbanked-receipts?cmpId=' + cmpId + '&user=' + user, { headers: authHeader() });
};

const getBankingTranCode = (cmpId) => {
  return axios.get(API_URLU + 'get-banking-trancode/' + cmpId, { headers: authHeader() });
};
const getBankingDocNumber = (data) => {
  return axios.get(API_URLU + 'get-banking-doc-number?tranCode=' + data.tranCode + '&docDate=' + data.docDate + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const postReceiptBankHeader = (data) => {
  return axios.post(API_URLU + 'bank-receipt-header', data, { headers: authHeader() });
};

const putReceiptBankHeader = (id, data) => {
  return axios.put(API_URLU + 'bank-receipt-header/' + id, data, { headers: authHeader() });
};

const postReceiptBankDetails = (data) => {
  return axios.post(API_URLU + 'receipt-banking-details', data, { headers: authHeader() });
};

const postPoEmails = (data) => {
  return axios.post(API_URLU + 'emailed-pos', data, { headers: authHeader() });
};

const getEmailedPoLPOs = (cmpId, phdID) => {
  return axios.get(API_URLU + 'emailed-pos/' + cmpId + '/' + phdID, { headers: authHeader() });
};

const getSupplierEmails = (cmpId, supplierCode) => {
  return axios.get(API_URLU + 'supplier-emails/' + cmpId + '/' + supplierCode, { headers: authHeader() });
};

const postSupplierEmails = (data) => {
  return axios.post(API_URLU + 'supplier-emails', data, { headers: authHeader() });
};
const putSupplierEmails = (seId, data) => {
  return axios.put(API_URLU + 'supplier-emails/' + seId, data, { headers: authHeader() });
};

const delSupplierEmails = (seId) => {
  return axios.delete(API_URLU + 'supplier-emails/' + seId, { headers: authHeader() });
};

const getCompanyBranches = (id) => {
  return axios.get(API_URLU + 'company-branches/' + id, { headers: authHeader() });
};
const putCompany = (cmpId, data) => {
  return axios.put(API_URLU + 'company/' + cmpId, data, { headers: authHeader() });
};
const getBranch = (id) => {
  return axios.get(API_URLU + 'branch/' + id, { headers: authHeader() });
};

const putBranch = (id, data) => {
  return axios.put(API_URLU + 'branch/' + id, data, { headers: authHeader() });
};
const postBranch = (data) => {
  return axios.post(API_URLU + 'branch', data, { headers: authHeader() });
};

const postHpAccount = (data) => {
  return axios.post(API_URLU + 'hp-accounts', data, { headers: authHeader() });
};

const postHpAccountGuarantor = (data) => {
  return axios.post(API_URLU + 'hp-account-guarantors', data, { headers: authHeader() });
};

const getHpAccountHist = (data) => {
  return axios.get(API_URLU + 'hp-account-hist?custCode=' + data.custCode + '&hpId=' + data.hpId + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getHpAccountGuarantorHist = (data) => {
  return axios.get(API_URLU + 'hp-quarantor-hist?custCode=' + data.custCode + '&hpId=' + data.hpId + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getHpAccByCustCode = (data) => {
  return axios.get(API_URLU + 'hp-accounts-cust-code?cmpId=' + data.cmpId + '&custCode=' + data.custCode, {
    headers: authHeader()
  });
};

const getHpAccByCmpId = (id) => {
  return axios.get(API_URLU + 'hp-accounts-cmpid?cmpId=' + id + '&activeYn=Y', {
    headers: authHeader()
  });
};

const getHpAccByHpNo = (data) => {
  return axios.get(API_URLU + 'hp-account-byHpno?custCode=' + data.custCode + '&hpNumber=' + data.hpNumber, {
    headers: authHeader()
  });
};

const getHpGuarantorsHistByHpNo = (data) => {
  return axios.get(API_URLU + 'hp-account-guarantors-byHpno?hpNumber=' + data.hpNumber, {
    headers: authHeader()
  });
};

const getHpAllAttachments = () => {
  return axios.get(API_URLU + 'hp-all-attachment', { headers: authHeader() });
};

const getHpAccGuarantors = (data) => {
  return axios.get(API_URLU + 'hp-account-guarantors-byHpId?cmpId=' + data.cmpId + '&hpId=' + data.hpId, { headers: authHeader() });
};

const getHpAccGuarantorsByCustCode = (cmpId) => {
  return axios.get(API_URLU + 'hp-account-guarantors-bygcustCode?cmpId=' + cmpId, { headers: authHeader() });
};

const genHPSchedule = (data) => {
  return axios.get(
    API_URLU +
      'gen-hp-schedule?instalAmount=' +
      data.instalAmount +
      '&agreementDate=' +
      data.agreementDate +
      '&instalMonths=' +
      data.instalMonths +
      '&username=' +
      data.username +
      '&hpId=' +
      data.hpId,
    { headers: authHeader() }
  );
};

const getHPSchedule = (id) => {
  return axios.get(API_URLU + 'get-hp-schedule?hpId=' + id, { headers: authHeader() });
};

const postHpDocs = (data) => {
  return axios.post(API_URLU + 'post-hp-attachment', data, { headers: authHeader() });
};

const getHpDocs = (id) => {
  return axios.get(API_URLU + 'get-hp-attachment?hpId=' + id, { headers: authHeader() });
};

const approveAndGenHpFin = (data) => {
  return axios.get(
    API_URLU +
      'approve-sale-header?cmpId=' +
      data.cmpId +
      '&sshId=' +
      data.sshId +
      '&hpId=' +
      data.hpId +
      '&hpNumber=' +
      data.hpNumber +
      '&username=' +
      data.username,
    { headers: authHeader() }
  );
};

const autoAllocReceipt = (data) => {
  return axios.get(API_URLU + 'auto-alloc-receipt?saleId=' + data.saleId + '&cmpId=' + data.cmpId + '&user=' + data.user, {
    headers: authHeader()
  });
};

const printReceipt = (id, data1) => {
  return axios.post(API_URLU + 'receipt-report/' + id, data1, { headers: authHeader() });
};

const getAmountToWords = (amount) => {
  return axios.get(API_URLU + 'amount-to-words/' + amount, { headers: authHeader() });
};

const autoGenerateReceipt = (data) => {
  return axios.post(API_URLU + 'auto-generate-receipt', data, { headers: authHeader() });
};

const getOriginalSaleReceipt = (saleId) => {
  return axios.get(API_URLU + 'get-sale-receipt/' + saleId, { headers: authHeader() });
};

const getSuspBal = (data) => {
  return axios.get(API_URLU + 'susp-bal?custCode=' + data.custCode + '&cmpId=' + data.cmpId + '&branchCode=' + data.branchCode, {
    headers: authHeader()
  });
};

const postReceiptSaleInfo = (data) => {
  return axios.post(API_URLU + 'receipt-sales-info', data, { headers: authHeader() });
};

const getHpReceipts = (cmpId, dconNo) => {
  return axios.get(API_URLU + 'hp-receipts/' + cmpId + '/' + dconNo, { headers: authHeader() });
};

const printHpStatement = (id, cmpId, custCode, data1) => {
  return axios.post(API_URLU + 'hp-statement-report/' + id + '/' + cmpId + '/' + custCode, data1, { headers: authHeader() });
};

const getDefaultAccounts = (cmpId) => {
  return axios.get(API_URLU + 'company-defaults/' + cmpId, { headers: authHeader() });
};

const getActiveHPAccounts = (data) => {
  return axios.get(API_URLU + 'hp-account-cust-nationalId?cmpId=' + data.cmpId + '&custCode=' + data.custCode, { headers: authHeader() });
};

const getCompanyUserBranches = (cmpId) => {
  return axios.get(API_URLU + 'get-company-user-branches/' + cmpId, { headers: authHeader() });
};
const getUnApprovedHanded = (cmpId, handedTo) => {
  return axios.get(API_URLU + 'handed-receipts/' + cmpId + '/' + handedTo, { headers: authHeader() });
};

const postHandedReceipts = (data) => {
  return axios.post(API_URLU + 'handed-receipts', data, { headers: authHeader() });
};

const putHandedReceipts = (id, data) => {
  return axios.put(API_URLU + 'handed-receipts/' + id, data, { headers: authHeader() });
};

const fetchHandedReceiptDetails = (cmpId, hdoId) => {
  return axios.get(API_URLU + 'handed-receipts-details/' + cmpId + '/' + hdoId, { headers: authHeader() });
};

const postHandedReceiptDetails = (data) => {
  return axios.post(API_URLU + 'handed-receipts-details', data, { headers: authHeader() });
};

const putHandedReceiptDetails = (id, data) => {
  return axios.put(API_URLU + 'handed-receipts-details/' + id, data, { headers: authHeader() });
};

const saveHeaderHdoId = (rhdId, hdoId) => {
  return axios.get(API_URLU + 'update-rct-header-hdoId/' + rhdId + '/' + hdoId, { headers: authHeader() });
};

const handOverForBanking = (cmpId, user) => {
  return axios.get(API_URLU + 'handover-for-banking/' + cmpId + '/' + user, { headers: authHeader() });
};

const updateHandedDetails = (data) => {
  return axios.get(
    API_URLU +
      'update-handed-details?hddId=' +
      data.hddId +
      '&cmpId=' +
      data.cmpId +
      '&bankedBy=' +
      data.bankedBy +
      '&bankBatchId=' +
      data.bankBatchId,
    { headers: authHeader() }
  );
};

const getUnapprovedBatches = (cmpId, createdBy) => {
  return axios.get(API_URLU + 'unapproved-receipt-batches/' + cmpId + '/' + createdBy, { headers: authHeader() });
};

const getApprovedBatches = (cmpId, user) => {
  return axios.get(API_URLU + 'get-approved-banked-receipts/' + cmpId + '/' + user, { headers: authHeader() });
};
const getBankedReceipts = (cmpId, rbhId) => {
  return axios.get(API_URLU + 'banked-receipts/' + cmpId + '/' + rbhId, { headers: authHeader() });
};
const postReceiptBanking = (data) => {
  return axios.get(
    API_URLU + 'post-receipt-banking?rbhId=' + data.rbhId + '&docDate=' + data.docDate + '&cmpId=' + data.cmpId + '&user=' + data.user,
    { headers: authHeader() }
  );
};

const poStocksForRejection = (cmpId, phdId) => {
  return axios.get(API_URLU + 'get-po-stocks-for-rejection/' + cmpId + '/' + phdId, { headers: authHeader() });
};

const transferStocksForRejection = (cmpId, sthId) => {
  return axios.get(API_URLU + 'get-transfer-stocks-for-rejection/' + cmpId + '/' + sthId, { headers: authHeader() });
};

const postRejectPos = (data) => {
  return axios.post(API_URLU + 'rejected-pos', data, { headers: authHeader() });
};

const putRejectPos = (id, data) => {
  return axios.put(API_URLU + 'rejected-pos/' + id, data, { headers: authHeader() });
};

const getRejectedGaas = (cmpId, status, user) => {
  return axios.get(API_URLU + 'get-rejected-gaas/' + cmpId + '/' + status + '/' + user, { headers: authHeader() });
};

const updateRejectedGaas = (cmpId, rpoId, action, user) => {
  return axios.get(API_URLU + 'update-rejected-gaas/' + cmpId + '/' + rpoId + '/' + action + '/' + user, { headers: authHeader() });
};

const getRejectedPoGaas = (data) => {
  return axios.get(
    API_URLU +
      'get-rejected-po-gaas?cmpId=' +
      data.cmpId +
      '&phdId=' +
      data.phdId +
      '&purchaseType=' +
      data.purchaseType +
      '&status=' +
      data.status,
    { headers: authHeader() }
  );
};

const getStockDescription = (sshId) => {
  return axios.get(API_URLU + 'get-stock-description/' + sshId, { headers: authHeader() });
};

const getCLientIdNumber = (custCode) => {
  return axios.get(API_URLU + 'get-client-id-Number/' + custCode, { headers: authHeader() });
};

const getStockAdjustmentHeaders = (data) => {
  return axios.get(
    API_URLU + 'stock-adjustment-headers?cmpId=' + data.cmpId + '&branchCode=' + data.branchCode + '&status=' + data.status,
    { headers: authHeader() }
  );
};

const postStockAdjustmentHeaders = (data) => {
  return axios.post(API_URLU + 'stock-adjustment-headers', data, { headers: authHeader() });
};

const putStockAdjustmentHeaders = (id, data) => {
  return axios.put(API_URLU + 'stock-adjustment-headers/' + id, data, { headers: authHeader() });
};

const getStockAdjustmentDetails = (id) => {
  return axios.get(API_URLU + 'stock-adjustment-details/' + id, { headers: authHeader() });
};

const postStockAdjustmentDetails = (data) => {
  return axios.post(API_URLU + 'stock-adjustment-details', data, { headers: authHeader() });
};

const putStockAdjustmentDetails = (id, data) => {
  return axios.put(API_URLU + 'stock-adjustment-details/' + id, data, { headers: authHeader() });
};

const getCustomerSaleItems = (data) => {
  return axios.get(
    API_URLU +
      'customer-sale-items?custCode=' +
      data.custCode +
      '&cmpId=' +
      data.cmpId +
      '&branchCode=' +
      data.branchCode +
      '&saleType=' +
      data.saleType,
    { headers: authHeader() }
  );
};

const insertAdjustmentDetails = (data) => {
  return axios.get(
    API_URLU +
      'insert-adjustment-details?sahId=' +
      data.sahId +
      '&tranCode=' +
      data.tranCode +
      '&stockCode=' +
      data.stockCode +
      '&cmpId=' +
      data.cmpId +
      '&sshId=' +
      data.sshId +
      '&custCode=' +
      data.custCode +
      '&description=' +
      data.description +
      '&branchCode=' +
      data.branchCode +
      '&user=' +
      data.user,
    { headers: authHeader() }
  );
};

const getStockAdjustmentsByStatus = (data) => {
  return axios.get(
    API_URLU + 'get-stock-adjustments-by-status?cmpId=' + data.cmpId + '&status=' + data.status + '&username=' + data.username,
    { headers: authHeader() }
  );
};

const genGlAdjustments = (data) => {
  return axios.get(
    'approve-adjustments?cmpId=' +
      data.cmpId +
      '&sahId=' +
      data.sahId +
      '&docDate=' +
      data.docDate +
      '&custName=' +
      data.custName +
      '&docType=' +
      data.docType +
      '&sshId=' +
      data.sshId,
    { headers: authHeader() }
  );
};

const getGlTransView = (cmpId) => {
  return axios.get(API_URLU + 'cfvgl-trans-view/' + cmpId, {
    headers: authHeader()
  });
};

const getGlTransViewId = (cmpId, gtdId) => {
  return axios.get(API_URLU + 'cfvgl-trans-view-id/' + cmpId + '/' + gtdId, {
    headers: authHeader()
  });
};

const getCustomerAttachments = (code) => {
  return axios.get(API_URLU + 'customer_attachments?custCode=' + code, { headers: authHeader() });
};

const postCustomerAttachments = (data) => {
  return axios.post(API_URLU + 'customer_attachments', data, { headers: authHeader() });
};

const linkInsuranceUser = (data) => {
  return axios.get(
    API_URLU +
      'link-insurance-user?cmpId=' +
      data.cmpId +
      '&sstId=' +
      data.sstId +
      '&usrId=' +
      data.usrId +
      '&accessCodeId=' +
      data.accessCodeId,
    { headers: authHeader() }
  );
};

const linkCmpMenus = (data) => {
  return axios.get(API_URLU + 'link-cmp-menus?cmpId=' + data.cmpId + '&sstId=' + data.sstId, { headers: authHeader() });
};

const getPremiumRates = () => {
  return axios.get(API_URLU + 'premium-rates', { headers: authHeader() });
};

const getPremiumRatesId = (insurerCode) => {
  return axios.get(API_URLU + 'premium-rates-id/' + insurerCode, { headers: authHeader() });
};

const getProvCoversCmpId = (cmpid) => {
  return axios.get(API_URLU + 'prov-covers-cmpid/' + cmpid, { headers: authHeader() });
};

const getPendingQuotationsCmpId = (cmpid) => {
  return axios.get(API_URLU + 'genpending-quotations-cmpid/' + cmpid, { headers: authHeader() });
};

const getConvertedQuotationsCmpId = (cmpid) => {
  return axios.get(API_URLU + 'genconverted-covers-cmpid/' + cmpid, { headers: authHeader() });
};

const getPendingCoversCmpId = (cmpid) => {
  return axios.get(API_URLU + 'genpending-covers-cmpid/' + cmpid, { headers: authHeader() });
};

const getActiveCoversCmpId = (cmpid) => {
  return axios.get(API_URLU + 'genactive-covers-cmpid/' + cmpid, { headers: authHeader() });
};

const getExpiredCoversCmpId = (cmpid) => {
  return axios.get(API_URLU + 'genexpired-covers-cmpid/' + cmpid, { headers: authHeader() });
};

const getRenewalsDueCmpId = (cmpid) => {
  return axios.get(API_URLU + 'genrenewals-due-cmpid/' + cmpid, { headers: authHeader() });
};

const getPolicyTranTypes = (cmpId) => {
  return axios.get(API_URLU + 'policy-tran-types/' + cmpId, { headers: authHeader() });
};

const getQuotationTranTypes = (cmpId) => {
  return axios.get(API_URLU + 'quotation-tran-types/' + cmpId, { headers: authHeader() });
};

const getRenewalTranTypes = (cmpId) => {
  return axios.get(API_URLU + 'renewal-tran-types/' + cmpId, { headers: authHeader() });
};

const getPolicyClassCodes = () => {
  return axios.get(API_URLU + 'policy-class-codes', { headers: authHeader() });
};

const getPolicyClassCodesByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'genclass-codes-cmpid/' + cmpId, { headers: authHeader() });
};

const getPolicyDeptCodesByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'gendept-codes-cmpid/' + cmpId, { headers: authHeader() });
};

const getPolicyClassgrpByClasscode = (classCode, cmpId) => {
  return axios.get(API_URLU + 'policy-classgrp-byclasscode/' + classCode + '/' + cmpId, { headers: authHeader() });
};

const getActiveInsurers = () => {
  return axios.get(API_URLU + 'active-geninsurer', { headers: authHeader() });
};

const getActiveInsurersByCmpid = (cmpId) => {
  return axios.get(API_URLU + 'geninsurer-cmpid/' + cmpId, { headers: authHeader() });
};

const getCompanyCurrencies = (cmpId) => {
  return axios.get(API_URLU + 'company-currencies/' + cmpId, { headers: authHeader() });
};

const getProvCoversByid = (prcId) => {
  return axios.get(API_URLU + 'genprov-covers-id/' + prcId, { headers: authHeader() });
};

const postProvCovers = (data) => {
  return axios.post(API_URLU + 'genprov-covers', data, { headers: authHeader() });
};

const putProvCovers = (prcId, data) => {
  return axios.put(API_URLU + 'genprov-covers/' + prcId, data, { headers: authHeader() });
};

const getProvCoversByCmpid = (cmpId) => {
  return axios.get(API_URLU + 'genprov-covers-cmpid/' + cmpId, { headers: authHeader() });
};

const getProvQuotationsByCmpid = (cmpId) => {
  return axios.get(API_URLU + 'genprov-quotations-cmpid/' + cmpId, { headers: authHeader() });
};

const copyInsuranceClasses = (data) => {
  return axios.get(API_URLU + 'copy-insurance-classes?fromCmpId=' + data.fromCmpId + '&toCmpId=' + data.toCmpId + '&user=' + data.user, {
    headers: authHeader()
  });
};

const copyInsuranceDepts = (data) => {
  return axios.get(API_URLU + 'copy-insurance-depts?fromCmpId=' + data.fromCmpId + '&toCmpId=' + data.toCmpId + '&user=' + data.user, {
    headers: authHeader()
  });
};

const getGenInsurersById = (insurerId) => {
  return axios.get(API_URLU + 'geninsurer-id/' + insurerId, { headers: authHeader() });
};

const postGenInsurers = (data) => {
  return axios.post(API_URLU + 'geninsurer', data, { headers: authHeader() });
};

const putGenInsurers = (insurerId, data) => {
  return axios.put(API_URLU + 'geninsurer/' + insurerId, data, { headers: authHeader() });
};

const getAllInsurersByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'all-geninsurer-cmpid/' + cmpId, { headers: authHeader() });
};

const getInsurerCustomersByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'insurance-customer-cmpid/' + cmpId, { headers: authHeader() });
};

const getOnluserInsurerCustomersByCmpId = (cmpId, usrId) => {
  return axios.get(API_URLU + 'onlusers-insurance-customer-cmpid/' + cmpId + '/' + usrId, { headers: authHeader() });
};

const getOnlineUsersToLinkByCmpId = (cmpId, usrId) => {
  return axios.get(API_URLU + 'onlusers-link-usrcmpid/' + cmpId + '/' + usrId, { headers: authHeader() });
};

const getCustTypeByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'cust-type-cmpid/' + cmpId, { headers: authHeader() });
};

const getIdentificationTypeByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'identification-type-cmpid/' + cmpId, { headers: authHeader() });
};

const getClientTypeByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'client-type-cmpid/' + cmpId, { headers: authHeader() });
};

const getOccupationCodesByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'occupation-codes-cmpid/' + cmpId, { headers: authHeader() });
};

const genInsureSerials = (data) => {
  return axios.get(API_URLU + 'gen-insure-serials?cmpId=' + data.cmpId, { headers: authHeader() });
};

const getInsuranceCustomerCode = (data) => {
  return axios.get(API_URLU + 'get-insurance-custcode?cmpId=' + data.cmpId, { headers: authHeader() });
};

const getOnlineCustomerCredentialsByUserId = (usrId, cmpId) => {
  return axios.get(API_URLU + 'cust-credentials-usrid/' + usrId + '/' + cmpId, { headers: authHeader() });
};

const postOnlineCredential = (data) => {
  return axios.post(API_URLU + 'customer-credentials', data, { headers: authHeader() });
};

const putOnlineCredential = (copId, data) => {
  return axios.put(API_URLU + 'customer-credentials/' + copId, data, { headers: authHeader() });
};

const getCustomerCredentialsById = (copId) => {
  return axios.get(API_URLU + 'customer-credentials/' + copId, { headers: authHeader() });
};

const getPermittedCustomerById = (copId) => {
  return axios.get(API_URLU + 'permitted-customers-id/' + copId, { headers: authHeader() });
};

const getCustCodeByIdAndCmpId = (cmpId, usrId) => {
  return axios.get(API_URLU + 'custcode-id-cmpid/' + cmpId + '/' + usrId, { headers: authHeader() });
};

const getCustomerPermittedUsers = (cmpId, usrId) => {
  return axios.get(API_URLU + 'cust-permitted-users/' + cmpId + '/' + usrId, { headers: authHeader() });
};

const getUsersPermittedForCustomers = (cmpId, custCode) => {
  return axios.get(API_URLU + 'users-permitted-cust/' + cmpId + '/' + custCode, { headers: authHeader() });
};

const getInsurancePolicyClassCodes = (cmpId) => {
  return axios.get(API_URLU + 'gen-polclass-codes-cmpid/' + cmpId, { headers: authHeader() });
};

const getDocControlNo = (data) => {
  return axios.get(API_URLU + 'get-dconno?cmpId=' + data.cmpId, { headers: authHeader() });
};

const getSystemUsersToLink = (cmpId, custCode) => {
  return axios.get(API_URLU + 'systemusers-link/' + cmpId + '/' + custCode, { headers: authHeader() });
};

const getAccessCode = (data) => {
  return axios.get(API_URLU + 'get-access-code?usrId=' + data.usrId + '&sstId=' + data.sstId + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const postGenProvRisks = (data) => {
  return axios.post(API_URLU + 'genprov-risks', data, { headers: authHeader() });
};

const postGenProvRiskSections = (data) => {
  return axios.post(API_URLU + 'genprov-risk-sects', data, { headers: authHeader() });
};

const getProvRisksByDconNo = (cmpId, dconNo) => {
  return axios.get(API_URLU + 'genprov-risks-dconno/' + cmpId + '/' + dconNo, { headers: authHeader() });
};

const getProvRiskSectionsByRiskId = (cmpId, prsId) => {
  return axios.get(API_URLU + 'genprov-risk-sects-riskid/' + cmpId + '/' + prsId, { headers: authHeader() });
};

const getProvRisksByid = (prsId) => {
  return axios.get(API_URLU + 'genprov-risks-id/' + prsId, { headers: authHeader() });
};

const putProvRisks = (prsId, data) => {
  return axios.put(API_URLU + 'genprov-risks/' + prsId, data, { headers: authHeader() });
};

const getProvRiskSectionsByid = (rscId) => {
  return axios.get(API_URLU + 'genprov-risk-sects-id/' + rscId, { headers: authHeader() });
};

const putRiskSections = (rscId, data) => {
  return axios.put(API_URLU + 'genprov-risk-sects/' + rscId, data, { headers: authHeader() });
};

const postProvFireDtl = (data) => {
  return axios.post(API_URLU + 'prov-fire-dtl', data, { headers: authHeader() });
};

const getProvFireDtlByid = (pfdId) => {
  return axios.get(API_URLU + 'prov-fire-dtl-id/' + pfdId, { headers: authHeader() });
};

const putProvFireDtl = (pfdId, data) => {
  return axios.put(API_URLU + 'prov-fire-dtl/' + pfdId, data, { headers: authHeader() });
};

const postProvMarineDtl = (data) => {
  return axios.post(API_URLU + 'prov-marine-dtl', data, { headers: authHeader() });
};

const getProvMarineDtlByid = (pmdId) => {
  return axios.get(API_URLU + 'prov-marine-dtl-id/' + pmdId, { headers: authHeader() });
};

const putProvMarineDtl = (pmdId, data) => {
  return axios.put(API_URLU + 'prov-marine-dtl/' + pmdId, data, { headers: authHeader() });
};

const postProvVehDtl = (data) => {
  return axios.post(API_URLU + 'prov-veh-dtl', data, { headers: authHeader() });
};

const getProvVehDtlByid = (pvdId) => {
  return axios.get(API_URLU + 'prov-veh-dtl-id/' + pvdId, { headers: authHeader() });
};

const putProvVehDtl = (pvdId, data) => {
  return axios.put(API_URLU + 'prov-veh-dtl/' + pvdId, data, { headers: authHeader() });
};

const getProvFireDtlByRiskid = (rscId) => {
  return axios.get(API_URLU + 'prov-fire-dtl-riskid/' + rscId, { headers: authHeader() });
};

const getProvMarineDtlByRiskid = (rscId) => {
  return axios.get(API_URLU + 'prov-marine-dtl-riskid/' + rscId, { headers: authHeader() });
};

const getProvVehDtlByRiskid = (rscId) => {
  return axios.get(API_URLU + 'prov-veh-dtl-riskid/' + rscId, { headers: authHeader() });
};

const getVehicleCoverTypes = (cmpId) => {
  return axios.get(API_URLU + 'genmotor-codes-cmpid/' + cmpId, { headers: authHeader() });
};

const getVehicleMakesByCmpid = (cmpId) => {
  return axios.get(API_URLU + 'genvehicle-makes-cmpid/' + cmpId, { headers: authHeader() });
};

const getVehicleModelsByMakeCode = (cmpId, makeCode) => {
  return axios.get(API_URLU + 'genvehicle-models-makecode/' + cmpId + '/' + makeCode, { headers: authHeader() });
};

const getClasssectByClassCodeandGrp = (classCode, classgrp, cmpId) => {
  return axios.get(API_URLU + 'genclasssect-byclasscode/' + classCode + '/' + classgrp + '/' + cmpId, { headers: authHeader() });
};

const getMarineGoodTypesCmpId = (cmpId) => {
  return axios.get(API_URLU + 'marine-good-types/' + cmpId, { headers: authHeader() });
};

const getVehicleBodyTypesCmpId = (cmpId) => {
  return axios.get(API_URLU + 'vehicle-body-types/' + cmpId, { headers: authHeader() });
};

const getMarinePackTypesCmpId = (cmpId) => {
  return axios.get(API_URLU + 'marine-pack-types/' + cmpId, { headers: authHeader() });
};

const getMarineVesselNamesCmpId = (cmpId) => {
  return axios.get(API_URLU + 'marine-vessel-names/' + cmpId, { headers: authHeader() });
};

const getRiskLocationsCmpId = (cmpId) => {
  return axios.get(API_URLU + 'risk-location-codes/' + cmpId, { headers: authHeader() });
};

const getProvLimitsByDconNo = (cmpId, dconNo) => {
  return axios.get(API_URLU + 'genprov-limits-dconno/' + cmpId + '/' + dconNo, { headers: authHeader() });
};

const getProvExcessByDconNo = (cmpId, dconNo) => {
  return axios.get(API_URLU + 'genprov-excess-dconno/' + cmpId + '/' + dconNo, { headers: authHeader() });
};

const getProvChargesByDconNo = (cmpId, dconNo) => {
  return axios.get(API_URLU + 'genprov-charges-dconno/' + cmpId + '/' + dconNo, { headers: authHeader() });
};

const getProvClausesByDconNo = (cmpId, dconNo) => {
  return axios.get(API_URLU + 'genprov-clauses-dconno/' + cmpId + '/' + dconNo, { headers: authHeader() });
};

const delProvRiskSectById = (rscId) => {
  return axios.delete(API_URLU + 'genprov-risk-sects/' + rscId, { headers: authHeader() });
};

const getRiskClassCodesByClassCode = (classCode, cmpId) => {
  return axios.get(API_URLU + 'risk-classcodes-byclasscode/' + classCode + '/' + cmpId, { headers: authHeader() });
};

const updateCoverPremium = (data) => {
  return axios.get(API_URLU + 'update-cover-premium?cmpId=' + data.cmpId + '&dconNo=' + data.dconNo, { headers: authHeader() });
};

const convertQuotationToCover = (data) => {
  return axios.get(API_URLU + 'convert-quotation-policy?cmpId=' + data.cmpId + '&dconNo=' + data.dconNo + '&transType=' + data.transType, {
    headers: authHeader()
  });
};

const findPaymentModesByCmpId = (cmpid) => {
  return axios.get(API_URLU + 'payment-modes-cmpid/' + cmpid, { headers: authHeader() });
};

const getInsurerById = (insurerId) => {
  return axios.get(API_URLU + 'geninsurer-id/' + insurerId, { headers: authHeader() });
};

const getInsurerPayBill = (cmpId, insurerCode) => {
  return axios.get(API_URLU + 'insurer-paybill/' + cmpId + '/' + insurerCode, { headers: authHeader() });
};

const getCompanyBankAccountsByCmpId = (cmpid) => {
  return axios.get(API_URLU + 'cfs-company-banks-cmpid/' + cmpid, { headers: authHeader() });
};

const getOnlinePreReceiptsbyDconno = (dconno) => {
  return axios.get(API_URLU + 'online-pre-receipts-dconno/' + dconno, { headers: authHeader() });
};

const countCoverOnlinePreReceipts = (data) => {
  return axios.get(API_URLU + 'count-online-pre-receipts?dconNo=' + data.dconNo, { headers: authHeader() });
};

const approveProvCover = (data) => {
  return axios.get(
    API_URLU + 'approve-prov-cover?dconNo=' + data.dconNo + '&cmpId=' + data.cmpId + '&user=' + data.user + '&brokerYn=' + data.brokerYn,
    { headers: authHeader() }
  );
};

const generateDocumentNumber = (data) => {
  return axios.get(
    API_URLU + 'gen-generate-document-number?serialCode=' + data.serialCode + '&cmpId=' + data.cmpId + '&companyClass=' + data.companyClass,
    { headers: authHeader() }
  );
};

const getInsuranceReport = (data) => {
  return axios.get(
    API_URLU +
      'insurace-report?reportFormat=' +
      data.reportFormat +
      '&repName=' +
      data.repName +
      '&cmpId=' +
      data.cmpId +
      '&userId=' +
      data.userId +
      '&dconNo=' +
      data.dconNo +
      '&signUrl=' +
      data.signUrl +
      '&username=' +
      data.username +
      '&custCode=' +
      data.custCode,
    {
      headers: authHeader()
    }
  );
};

const getInsuranceReportsByCmpId = (cmpid) => {
  return axios.get(API_URLU + 'insurance-reports-cmpid/' + cmpid, { headers: authHeader() });
};

const getReinsCodes = () => {
  return axios.get(API_URLU + 'reins-codes', { headers: authHeader() });
};

const PostReinsCodes = (data) => {
  return axios.post(API_URLU + 'reins-codes', data, { headers: authHeader() });
};

const PutReinsCodes = (data) => {
  return axios.put(API_URLU + 'reins-codes/' + data.reinId, data, { headers: authHeader() });
};

const getReinsCtl = () => {
  return axios.get(API_URLU + 'reins-ctl', { headers: authHeader() });
};

const getGenYrs = (id) => {
  return axios.get(API_URLU + 'gen-years?cmpId=' + id, { headers: authHeader() });
};

const PostGenYrs = (data) => {
  return axios.post(API_URLU + 'gen-years', data, { headers: authHeader() });
};

const PutGenYrs = (data) => {
  return axios.put(API_URLU + 'gen-years/' + data.gyrId, data, { headers: authHeader() });
};

const getTreatyTypes = () => {
  return axios.get(API_URLU + 'treaty-types', { headers: authHeader() });
};

const postTreatyTypes = (data) => {
  return axios.post(API_URLU + 'treaty-types', data, { headers: authHeader() });
};

const putTreatyTypes = (data) => {
  return axios.put(API_URLU + 'treaty-types/' + data.treatyId, data, { headers: authHeader() });
};

const getRiModes = () => {
  return axios.get(API_URLU + 'ri-modes', { headers: authHeader() });
};

const postRiModes = (data) => {
  return axios.post(API_URLU + 'ri-modes', data, { headers: authHeader() });
};

const putRiModes = (data) => {
  return axios.put(API_URLU + 'ri-modes/' + data.rtypeId, data, { headers: authHeader() });
};

const getTreatyHeaders = (calendarYear) => {
  return axios.get(API_URLU + 'treaty-headers?treatyYear=' + calendarYear, { headers: authHeader() });
};

const postTreatyHeaders = (data) => {
  return axios.post(API_URLU + 'treaty-headers', data, { headers: authHeader() });
};

const putTreatyHeaders = (data) => {
  return axios.put(API_URLU + 'treaty-headers/' + data.trhId, data, { headers: authHeader() });
};

const getTreatyDetails = (trhId) => {
  return axios.get(API_URLU + 'treaty-details?trhId=' + trhId, { headers: authHeader() });
};

const postTreatyDetails = (data) => {
  return axios.post(API_URLU + 'treaty-details', data, { headers: authHeader() });
};

const putTreatyDetails = (data) => {
  return axios.put(API_URLU + 'treaty-details/' + data.trdId, data, { headers: authHeader() });
};

const getTreatyPartics = (trdId) => {
  return axios.get(API_URLU + 'treaty-pertics?trdId=' + trdId, { headers: authHeader() });
};

const postTreatyPartics = (data) => {
  return axios.post(API_URLU + 'treaty-pertics', data, { headers: authHeader() });
};

const putTreatyPartics = (data) => {
  return axios.put(API_URLU + 'treaty-pertics/' + data.tprId, data, { headers: authHeader() });
};

const getTreatyAllDeparts = () => {
  return axios.get(API_URLU + 'treaty-classes-all', { headers: authHeader() });
};

const getTreatyDeparts = (code) => {
  return axios.get(API_URLU + 'treaty-classes?reinsDeptCode=' + code, { headers: authHeader() });
};

const copyTreatySetups = (data) => {
  return axios.get(API_URLU + 'treaty-copy?fromYear=' + data.fromYear + '&toYear=' + data.toYear + '&user=' + data.user, {
    headers: authHeader()
  });
};

const getReinsurers = () => {
  return axios.get(API_URLU + 'gen-reinsurers', { headers: authHeader() });
};

const postReinsurers = (data) => {
  return axios.post(API_URLU + 'gen-reinsurers', data, { headers: authHeader() });
};

const putReinsurers = (data) => {
  return axios.put(API_URLU + 'gen-reinsurers/' + data.rcdId, data, { headers: authHeader() });
};

const getDoCombUwReins = (data) => {
  return axios.get(API_URLU + 'do_comb_uw_reinsurance?dconNo=' + data.dconNo + '&cmpId=' + data.cmpId + '&username=' + data.username, {
    headers: authHeader()
  });
};

const getDoUwReins = (data) => {
  return axios.get(API_URLU + 'do_uw_reinsurance?dconNo=' + data.dconNo + '&cmpId=' + data.cmpId + '&username=' + data.username, {
    headers: authHeader()
  });
};

const getPolreinsHeader = (data) => {
  return axios.get(API_URLU + 'gen-reinPol-headers?dconNo=' + data.dconNo + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const generatePolicyNumber = (data) => {
  return axios.get(API_URLU + 'generate-policy-number?cmpId=' + data.cmpId, { headers: authHeader() });
};

const getActiveProvCoversByClientNumber = (data) => {
  return axios.get(API_URLU + 'genactive-covers-client-number?cmpId=' + data.cmpId + '&clientNumber=' + data.clientNumber, {
    headers: authHeader()
  });
};

const getClaimTypesByClassCode = (data) => {
  return axios.get(API_URLU + 'gen-claim-types?cmpId=' + data.cmpId + '&notifClassCode=' + data.notifClassCode, { headers: authHeader() });
};

const getPoliciesForClaimsByCmpId = (data) => {
  return axios.get(API_URLU + 'genpolicies-claims-cmpid?cmpId=' + data.cmpId + '&claimDate=' + data.claimDate, { headers: authHeader() });
};

const postClaimNotifications = (data) => {
  return axios.post(API_URLU + 'gen-notif-claims', data, { headers: authHeader() });
};

const putClaimNotifications = (data) => {
  return axios.put(API_URLU + 'gen-notif-claims/' + data.nclId, data, { headers: authHeader() });
};

const getBranchesByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'branches-cmpid/' + cmpId, { headers: authHeader() });
};

const getPendGenClaimNotifsByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'pend-notif-claims-cmpid/' + cmpId, { headers: authHeader() });
};

const getConvGenClaimNotifsByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'conv-notif-claims-cmpid/' + cmpId, { headers: authHeader() });
};

const getCustPoliciesForClaimsByCmpId = (data) => {
  return axios.get(
    API_URLU + 'cust-genpolicies-claims-cmpid?cmpId=' + data.cmpId + '&claimDate=' + data.claimDate + '&clientNumber=' + data.clientNumber,
    { headers: authHeader() }
  );
};

const getGenClmNotifDocsByNotifId = (notifId) => {
  return axios.get(API_URLU + 'genclm-notifdocs-notifid/' + notifId, { headers: authHeader() });
};

const generateClaimNotifDocs = (data) => {
  return axios.get(
    API_URLU + 'gen-claim-notif-docs?nclId=' + data.nclId + '&estCode=' + data.estCode + '&user=' + data.user + '&cmpId=' + data.cmpId,
    { headers: authHeader() }
  );
};

const putGenClmNotifDocs = (data) => {
  return axios.put(API_URLU + 'genclm-notifdocs/' + data.cdcId, data, { headers: authHeader() });
};

const getDeclGenClaimNotifsByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'decl-notif-claims-cmpid/' + cmpId, { headers: authHeader() });
};

const approveClaimNotifications = (data) => {
  return axios.get(
    API_URLU +
      'gen-approve-claim-notifications?nclId=' +
      data.nclId +
      '&cmpId=' +
      data.cmpId +
      '&user=' +
      data.user +
      '&status=' +
      data.status,
    { headers: authHeader() }
  );
};

const getPendGenClaimsByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'genpend-claims-cmpid/' + cmpId, { headers: authHeader() });
};

const getApprGenClaimsByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'genappr-claims-cmpid/' + cmpId, { headers: authHeader() });
};

const getDeclinedGenClaimsByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'genrej-claims-cmpid/' + cmpId, { headers: authHeader() });
};

const getGenClmDocsByClmId = (clmId) => {
  return axios.get(API_URLU + 'gen-clm-docs-clmid/' + clmId, { headers: authHeader() });
};

const getGenClmEstimatesByClmId = (clmId) => {
  return axios.get(API_URLU + 'genclm-estimates-clmid/' + clmId, { headers: authHeader() });
};

const postGenClaimEstimates = (data) => {
  return axios.post(API_URLU + 'genclm-estimates', data, { headers: authHeader() });
};

const putGenClaimEstimates = (data) => {
  return axios.put(API_URLU + 'genclm-estimates/' + data.estId, data, { headers: authHeader() });
};

const getAllCustPoliciesByCmpId = (data) => {
  return axios.get(API_URLU + 'allcust-genpolicies-cmpid?cmpId=' + data.cmpId + '&clientNumber=' + data.clientNumber, {
    headers: authHeader()
  });
};

const getGenProvRisksByPolicyNumberAndCmpId = (data) => {
  return axios.get(API_URLU + 'genprov-risks-policyno?cmpId=' + data.cmpId + '&policyNumber=' + data.policyNumber, {
    headers: authHeader()
  });
};

const getGenerateRiProc = (data) => {
  return axios.get(API_URLU + 'gen-generate-ri?dconNo=' + data.dconNo + '&cmpId=' + data.cmpId + '&username=' + data.username, {
    headers: authHeader()
  });
};

const getPolreinsDetail = (plhId) => {
  return axios.get(API_URLU + 'gen-reinPol-details?plhId=' + plhId, {
    headers: authHeader()
  });
};

const getPolreinsPartics = (pldId) => {
  return axios.get(API_URLU + 'gen-reinPol-partics?pldId=' + pldId, {
    headers: authHeader()
  });
};

const getPolreinsParticsOveral = (id) => {
  return axios.get(API_URLU + 'gen-reinPol-partics-overal?id=' + id, {
    headers: authHeader()
  });
};

const getUndoFacult = (data) => {
  return axios.get(API_URLU + 'gen-undo-facult?plpId=' + data.plpId, {
    headers: authHeader()
  });
};

const getretainxtraPrem = (data) => {
  return axios.get(API_URLU + 'gen-retain-xtra-prem?dconNo=' + data.dconNo + '&reinsPremBalance=' + data.reinsPremBalance, {
    headers: authHeader()
  });
};

const getPurgeRI = (data) => {
  return axios.get(API_URLU + 'gen-purge-ri?dconNo=' + data.dconNo + '&plhId=' + data.plhId, {
    headers: authHeader()
  });
};

const getCloseRI = (data) => {
  return axios.get(
    API_URLU + 'gen-close-ri?plhId=' + data.plhId + '&reinsSIBalance=' + data.reinsSIBalance + '&reinsPremBalance=' + data.reinsPremBalance,
    {
      headers: authHeader()
    }
  );
};

const getFacultPlacing = (data) => {
  return axios.get(
    API_URLU +
      'gen-place-facult?plhId=' +
      data.plhId +
      '&dconNo=' +
      data.dconNo +
      '&reinsSIBalance=' +
      data.reinsSIBalance +
      '&reinsPremBalance=' +
      data.reinsPremBalance +
      '&reinsEqPremBalance=' +
      data.reinsEqPremBalance +
      '&username=' +
      data.username,
    {
      headers: authHeader()
    }
  );
};

const getReinBrokers = () => {
  return axios.get(API_URLU + 'gen-rein-brokers', { headers: authHeader() });
};

const postReinBrokers = (data) => {
  return axios.post(API_URLU + 'gen-rein-brokers', data, { headers: authHeader() });
};

const putReinBrokers = (data) => {
  return axios.put(API_URLU + 'gen-rein-brokers/' + data.rbcId, data, { headers: authHeader() });
};

const postReinDepts = (data) => {
  return axios.post(API_URLU + 'treaty-classes', data, { headers: authHeader() });
};

const putReinDepts = (data) => {
  return axios.put(API_URLU + 'treaty-classes/' + data.rdpId, data, { headers: authHeader() });
};

const getLinking = (data) => {
  return axios.get(API_URLU + 'link-class?cmpId=' + data.cmpId + '&classId=' + data.classId + '&deptCode=' + data.deptCode, {
    headers: authHeader()
  });
};

export default {
  getUserById,
  getPendingSales,
  postSale,
  delSale,
  putSale,
  getSalesByDate,
  getSalesByShop,
  getUserShops,
  getDaySales,
  getUserSales,
  getAllSales,
  getUsers,
  postUser,
  getCompById,
  getCompanies,
  postComp,
  getInsuranceCompanies,
  getSystemById,
  getSystems,
  postSystem,
  postUserComp,
  postUserSystems,
  getUserComp,
  getCompSystems,
  getUserCompSystems,
  getUserCompUSystems,
  getCustomerById,
  getCustomers,
  postCustomer,
  putCustomer,
  getEmployeeById,
  getEmployeeByUsername,
  getEmployees,
  getPagedEmployees,
  postEmployee,
  putEmployee,
  getClassification,
  getGeneral,
  getFiles,
  saveInvoice,
  getInvoiceInfo,
  getScheduledLeaves,
  postLeaveSchedule,
  getLeaveAccruals,
  getLeaveApplications,
  postLeaveApplication,
  getLeaveTransactions,
  getLeaveRejections,
  getLeaveTypes,
  getReturnDate,
  uploadFile,
  uploadExcel,
  postTempBranch,
  getTempBranch,
  getPastDays,
  postDay,
  getDaysStatus,
  putDay,
  getMaxDate,
  getSaleStatus,
  updatePass,
  updateUser,
  updateUserImg,
  getApprovedSales,
  getAdminSalesByDate,
  getAllShops,
  getAdminSalesByShop,
  getStockCodes,
  getQuoteId,
  getQuoteInfo,
  delQuote,
  getQuoteReport,
  postQuoteHeader,
  postQuoteDetails,
  genCombinedQuote,
  getCombinedQuotes,
  archCombQuote,
  listSingleQuoutes,
  listCombinedQuoutes,
  companyVatRates,
  checkVatDates,
  postVatRates,
  delVatRate,
  putVatRate,
  companyStdRates,
  postStandardRates,
  delStdRate,
  putStdRate,
  companyGenRates,
  postGeneralRates,
  delGenRate,
  putGenRate,
  currentPeriods,
  pastPeriods,
  closePeriod,
  postNewPeriod,
  putIstPeriod,
  getCompanyProducts,
  getProductDetails,
  postIstProducts,
  putIstProducts,
  delIstProduct,
  getCompanySuppliers,
  getSupplierDetails,
  postIstSuppliers,
  putIstSuppliers,
  getSupplierStocks,
  getSupplerProductDetails,
  putIstSupplierProducts,
  getCombinedSingle,
  updateStockQuote,
  postIstSupplierProducts,
  getCompanyTariffPeriods,
  getTariffCashRates,
  getRateDetails,
  putCashRateDetails,
  getCheckOffMarkupPercs,
  getMarkupPercDetails,
  putMarkupDetails,
  closeTariffPeriod,
  getTrpHpDeposit,
  getHPDepositDetails,
  putHpDepositDetails,
  getTrpDiscounts,
  getDiscountDetails,
  putDiscountDetails,
  getTrpInstalMonths,
  getInstalMonthsDetails,
  putInstalMonths,
  getHpMarkupRates,
  getMarkupDetails,
  putMarkupRates,
  getHpMarkupPercs,
  getMarkupPerc,
  putMarkupPercs,
  copyPeriods,
  getProductHist,
  getCompanyStocks,
  postCashRateDetails,
  delCashRate,
  postMarkupDetails,
  delMarkup,
  postHpDepositDetails,
  delHpDepositDetails,
  postDiscountDetails,
  delDiscountDetails,
  postInstalMonths,
  delInstalMonths,
  postMarkupRates,
  delMarkupRate,
  getPriceCataloq,
  getJointYn,
  getJointStockCodes,
  getStockCatalogue,
  getActiveStocks,
  getMinDate,
  getStockCheckOff,
  getSupplierPriceList,
  getSupplierPastPriceList,
  updatePriceCatalogue,
  addNewPriceListItem,
  updatePriceList,
  UpdateAllPrices,
  getJointStocks,
  addJointStocks,
  getUserRights,
  approveVATRates,
  approveSTDRates,
  approveGENRates,
  approvePeriod,
  allPeriods,
  clearStockPrices,
  updateStockPrices,
  updateTariffPeriod,
  approvetariffPeriod,
  getCataloguePeriods,
  inteGrateWithKct,
  getCompanyStockCodes,
  genNoneStockQuote,
  listNonStockQuotes,
  approveCashRate,
  approveCheckOff,
  getActiveEndDate,
  approveStock,
  getMenuLevels,
  getAddTempItem,
  getPoH,
  getPoHVW,
  getReqH,
  getPoD,
  getReqD,
  getPolNo,
  postPoH,
  postPoD,
  getReqSummary,
  getPoSummary,
  getPohApproval,
  getPurchaseReport,
  getCustomerByCmpId,
  genCombQuoteHeader,
  genCombNoneStockQuote,
  listCombNonStockQuotes,
  getCombQuoteReport,
  postGaaH,
  postGaaD,
  getUpdatePoDetails,
  getPoNotInGaa,
  getGaaHVW,
  getGaaHVWItems,
  getUserBranches,
  generateCombinedNonStockQuote,
  genCombQuoteNoneStockDetails,
  postGap,
  postStkTransH,
  postStkTransD,
  getShopTransfers,
  getShopTransferDetails,
  getTransferInvoiceReport,
  getSupplierEmail,
  sendLpoMail,
  getReceiptTranCodes,
  getPaymentModes,
  getCustomerCodes,
  getPolicyInformation,
  getAddress,
  getAllBankAccounts,
  getDocDetails,
  docAvailable,
  postReceiptHeader,
  putReceiptHeader,
  postReceiptDetails,
  putReceiptDetails,
  getReceiptDetails,
  getCompanyBanks,
  getReceiptHeaderApprovalStatus,
  approveReceiptHeader,
  saleItems,
  postSalesHeader,
  postSalesDetails,
  postSalesParticular,
  getSalesHeader,
  getCustomerByCmpIdAndId,
  getGapItemsByGaaNo,
  poReports,
  getPoReportDetails,
  getPurchaseReport2,
  updateMialSent,
  cancelPO,
  getSaleTypes,
  companyReceipts,
  getSelectedReceiptDetails,
  getAllCreditAccounts,
  getPaymentHeaders,
  getPaymentDetailsByHeaderId,
  getInvoiceTransactionCodes,
  getPaymentTransactionCodes,
  getInvoiceHeaders,
  getOurRef,
  getMainAccounts,
  getSubAccountsByMain,
  getCustBank,
  getBranches,
  getDepartments,
  postPaymentDetails,
  postPaymentHeaders,
  putPaymentHeaders,
  getPaymentHeaderByHeaderId,
  postGltranHeaders,
  postGltranDetails,
  getPaymentReport,
  getPaymentDetails,
  getAllPaymentHeaders,
  approvePaymentHeader,
  getPaymentDocNumber,
  getInvoiceBalance,
  findPaymentModes,
  getTranTypes,
  linkCustomerAccount,
  getLinkedCustomerAccounts,
  getUnbankedReceipts,
  getCustomerSubaccounts,
  generateCustomerSubaccount,
  getBankingTranCode,
  getBankingDocNumber,
  postReceiptBankHeader,
  postReceiptBankDetails,
  getGaaDByGaaNo,
  getSaleFinTrans,
  genSaleFinTrans,
  getSalesDetailsBySshId,
  getSalesParticularBySshId,
  getSaleInformation,
  deleteReceiptDetail,
  postPoEmails,
  getEmailedPoLPOs,
  getSupplierEmails,
  postSupplierEmails,
  putSupplierEmails,
  delSupplierEmails,
  getCompanyBranches,
  putCompany,
  getBranch,
  putBranch,
  postBranch,
  postHpAccount,
  postHpAccountGuarantor,
  getHpAccountHist,
  getHpAccountGuarantorHist,
  getHpAccByCustCode,
  getCertReport,
  getHpAccByHpNo,
  getHpGuarantorsHistByHpNo,
  getHpAllAttachments,
  getHpAccByCmpId,
  getHPSalesHeader,
  getHPPreSalesHeader,
  getHpAccGuarantors,
  genHPSchedule,
  getHPSchedule,
  postHpDocs,
  getHpDocs,
  approveAndGenHpFin,
  autoAllocReceipt,
  printReceipt,
  getAmountToWords,
  autoGenerateReceipt,
  getReceiptHeader,
  getOriginalSaleReceipt,
  getSuspBal,
  getPoReportDetailsByPhd,
  postReceiptSaleInfo,
  postSaleFinGL,
  deletePaymentDetails,
  getHpReceipts,
  printHpStatement,
  getCompanyUserBranches,
  getUnApprovedHanded,
  postHandedReceipts,
  putHandedReceipts,
  fetchHandedReceiptDetails,
  postHandedReceiptDetails,
  putHandedReceiptDetails,
  saveHeaderHdoId,
  handOverForBanking,
  updateHandedDetails,
  getUnapprovedBatches,
  getApprovedBatches,
  getBankedReceipts,
  uploadBankReceipt,
  postReceiptBanking,
  putReceiptBankHeader,
  poStocksForRejection,
  transferStocksForRejection,
  postRejectPos,
  putRejectPos,
  getRejectedGaas,
  updateRejectedGaas,
  getRejectedPoGaas,
  getStockDescription,
  getCLientIdNumber,
  getDefaultAccounts,
  postPaymentParticulars,
  getPoHBalnce,
  getActiveHPAccounts,
  getHpAccGuarantorsByCustCode,
  getStockAdjustmentHeaders,
  postStockAdjustmentHeaders,
  putStockAdjustmentHeaders,
  getStockAdjustmentDetails,
  postStockAdjustmentDetails,
  putStockAdjustmentDetails,
  getCustomerSaleItems,
  insertAdjustmentDetails,
  getStockAdjustmentsByStatus,
  genGlAdjustments,
  getGlTransView,
  getGlTransViewId,
  getCustomerAttachments,
  postCustomerAttachments,
  linkInsuranceUser,
  linkCmpMenus,
  getPremiumRates,
  getPremiumRatesId,
  getProvCoversCmpId,
  postProvCovers,
  getPolicyTranTypes,
  getPolicyClassCodes,
  getPolicyClassgrpByClasscode,
  getActiveInsurers,
  getCompanyCurrencies,
  getProvCoversByid,
  putProvCovers,
  getProvCoversByCmpid,
  getActiveInsurersByCmpid,
  getPolicyClassCodesByCmpId,
  copyInsuranceDepts,
  copyInsuranceClasses,
  getGenInsurersById,
  postGenInsurers,
  putGenInsurers,
  getAllInsurersByCmpId,
  getInsurerCustomersByCmpId,
  getCustTypeByCmpId,
  getIdentificationTypeByCmpId,
  getClientTypeByCmpId,
  getOccupationCodesByCmpId,
  genInsureSerials,
  getInsuranceCustomerCode,
  getOnlineCustomerCredentialsByUserId,
  postOnlineCredential,
  putOnlineCredential,
  getCustomerCredentialsById,
  getCustCodeByIdAndCmpId,
  getOnluserInsurerCustomersByCmpId,
  getInsurancePolicyClassCodes,
  getOnlineUsersToLinkByCmpId,
  getDocControlNo,
  getCustomerPermittedUsers,
  getUsersPermittedForCustomers,
  getSystemUsersToLink,
  getAccessCode,
  getPermittedCustomerById,
  postGenProvRisks,
  postGenProvRiskSections,
  getProvRisksByDconNo,
  getProvRiskSectionsByRiskId,
  getProvRisksByid,
  putProvRisks,
  getProvRiskSectionsByid,
  putRiskSections,
  postProvFireDtl,
  getProvFireDtlByid,
  putProvFireDtl,
  postProvMarineDtl,
  getProvMarineDtlByid,
  putProvMarineDtl,
  postProvVehDtl,
  getProvVehDtlByid,
  putProvVehDtl,
  getProvFireDtlByRiskid,
  getProvMarineDtlByRiskid,
  getProvVehDtlByRiskid,
  getVehicleCoverTypes,
  getVehicleMakesByCmpid,
  getVehicleModelsByMakeCode,
  getClasssectByClassCodeandGrp,
  getMarineGoodTypesCmpId,
  getMarinePackTypesCmpId,
  getVehicleBodyTypesCmpId,
  getMarineVesselNamesCmpId,
  getRiskLocationsCmpId,
  getProvLimitsByDconNo,
  getProvExcessByDconNo,
  getProvChargesByDconNo,
  getProvClausesByDconNo,
  delProvRiskSectById,
  getRiskClassCodesByClassCode,
  updateCoverPremium,
  getQuotationTranTypes,
  getProvQuotationsByCmpid,
  getRenewalTranTypes,
  getConvertedQuotationsCmpId,
  getPendingQuotationsCmpId,
  getActiveCoversCmpId,
  getPendingCoversCmpId,
  getRenewalsDueCmpId,
  getExpiredCoversCmpId,
  convertQuotationToCover,
  findPaymentModesByCmpId,
  getInsurerById,
  getInsurerPayBill,
  getCompanyBankAccountsByCmpId,
  getOnlinePreReceiptsbyDconno,
  approveProvCover,
  countCoverOnlinePreReceipts,
  generateDocumentNumber,
  getInsuranceReport,
  getInsuranceReportsByCmpId,
  getReinsCodes,
  getReinsCtl,
  getGenYrs,
  getTreatyTypes,
  getRiModes,
  getTreatyHeaders,
  getTreatyDetails,
  getTreatyPartics,
  PostGenYrs,
  PutGenYrs,
  getTreatyDeparts,
  getTreatyAllDeparts,
  postTreatyHeaders,
  putTreatyHeaders,
  postTreatyDetails,
  putTreatyDetails,
  postTreatyPartics,
  putTreatyPartics,
  copyTreatySetups,
  PostReinsCodes,
  PutReinsCodes,
  postTreatyTypes,
  putTreatyTypes,
  postRiModes,
  putRiModes,
  getReinsurers,
  postReinsurers,
  putReinsurers,
  getDoCombUwReins,
  getDoUwReins,
  getPolreinsHeader,
  generatePolicyNumber,
  getActiveProvCoversByClientNumber,
  getClaimTypesByClassCode,
  getPoliciesForClaimsByCmpId,
  putClaimNotifications,
  postClaimNotifications,
  getBranchesByCmpId,
  getPendGenClaimNotifsByCmpId,
  getConvGenClaimNotifsByCmpId,
  getCustPoliciesForClaimsByCmpId,
  generateClaimNotifDocs,
  getGenClmNotifDocsByNotifId,
  putGenClmNotifDocs,
  getDeclGenClaimNotifsByCmpId,
  approveClaimNotifications,
  getPendGenClaimsByCmpId,
  getApprGenClaimsByCmpId,
  getDeclinedGenClaimsByCmpId,
  getGenClmDocsByClmId,
  getGenClmEstimatesByClmId,
  putGenClaimEstimates,
  postGenClaimEstimates,
  getAllCustPoliciesByCmpId,
  getGenProvRisksByPolicyNumberAndCmpId,
  getGenerateRiProc,
  getPolreinsDetail,
  getPolreinsPartics,
  getUndoFacult,
  getretainxtraPrem,
  getPurgeRI,
  getCloseRI,
  getFacultPlacing,
  getPolreinsParticsOveral,
  getReinBrokers,
  postReinBrokers,
  putReinBrokers,
  postReinDepts,
  putReinDepts,
  getPolicyDeptCodesByCmpId,
  getLinking
};
